export const eventCategories = [
  "Research Conferences",
  "Humanoid Robots",
  "Industrial Automation",
  "AI Robotics",
  "Physical AI",
  "Human Robot Interaction",
  "Medical Robotics",
  "Warehouse Robotics",
  "Drone Robotics",
  "Robot Components",
  "Startup and Investor Events",
  "Robotics Competitions",
  "Robotics Software",
  "Consumer Robotics",
  "Smart Manufacturing"
];

export const eventRegions = [
  "China",
  "Japan",
  "United States",
  "North America",
  "Europe",
  "Middle East",
  "United Arab Emirates",
  "Africa",
  "Asia Pacific",
  "Global online events",
  "Singapore",
  "Thailand",
  "South Korea"
];

export const roboticsEvents = [
  {
    "id": "beijing-yizhuang-humanoid-half-marathon-2026",
    "name": "Beijing Yizhuang Humanoid Robot Half Marathon 2026",
    "originalName": "2026北京亦庄人形机器人半程马拉松",
    "officialEnglishName": "Beijing Yizhuang Humanoid Robot Half Marathon 2026",
    "slug": "beijing-yizhuang-humanoid-half-marathon-2026",
    "eventType": "Competition",
    "category": "Robotics Competitions",
    "country": "China",
    "city": "Beijing",
    "region": "China",
    "dateStart": "2026-04-19",
    "dateEnd": "2026-04-19",
    "month": "April 2026",
    "venue": "Beijing E-Town course from Kechuang 17th Street to Nanhaizi Park South Gate",
    "website": "https://www.beijing.gov.cn/ywdt/gzdt/202604/t20260421_4600210.html",
    "source": "Beijing Municipal Government and Beijing E-Town official reports",
    "lastChecked": "September 3, 2026",
    "description": "A 21.0975 km humanoid robot road race in Beijing E-Town. More than 100 humanoid teams entered in 2026 alongside 12,000 human runners. Honor's Qitian Dasheng team won the robot race with its Lightning humanoid in a net time of 50 minutes 26 seconds.",
    "audience": [
      "humanoid robot teams",
      "robotics researchers",
      "universities",
      "motion control engineers",
      "robotics media"
    ],
    "mainTopics": [
      "humanoid locomotion",
      "long duration running",
      "autonomous navigation",
      "remote control",
      "battery management",
      "thermal management"
    ],
    "organizers": [
      "People's Government of Beijing Municipality",
      "China Media Group",
      "Chinese Institute of Electronics",
      "World Robot Cooperation Organization"
    ],
    "verifiedFacts": [
      "The robot course covered 21.0975 km and started at 07:30 on April 19, 2026.",
      "More than 100 humanoid teams from 11 Chinese provincial-level regions entered. Five international teams also participated.",
      "The field included autonomous navigation and remote control entries. Official Beijing reporting put autonomous navigation at about 40 percent of the robot field.",
      "Teams included Beijing Humanoid Robot Innovation Center, Honor, Unitree and 松延动力, plus groups from Tsinghua University, Peking University and the University of Science and Technology of China.",
      "Lightning from Honor's Qitian Dasheng team won in 50 minutes 26 seconds. Honor teams also took second and third place."
    ],
    "featuredRobots": [
      "Lightning by Honor, first place, 50 minutes 26 seconds",
      "Tiangong humanoid platform from Beijing Humanoid Robot Innovation Center",
      "Unitree humanoid entries"
    ],
    "technologyHighlights": [
      "whole body locomotion",
      "autonomous perception and navigation",
      "remote control",
      "motor cooling",
      "battery replacement strategy"
    ],
    "officialLinks": [
      { "label": "Official Beijing event report", "url": "https://www.beijing.gov.cn/ywdt/gzdt/202604/t20260421_4600210.html" },
      { "label": "Official Beijing E-Town result", "url": "https://kfqgw.beijing.gov.cn/ywdt/gdcyfzgd/zncx/202604/t20260420_4596389.html" }
    ],
    "whyItMatters": "The outdoor half marathon exposes humanoid locomotion to distance, battery limits, heat, changing light, curves and public road conditions that short indoor runs do not reproduce.",
    "bestFor": [
      "humanoid locomotion",
      "robot endurance",
      "autonomy disclosure",
      "China humanoid competitions"
    ],
    "priceRange": "Check official organizer information.",
    "deadline": "The 2026 race is complete.",
    "applicationDeadline": "The 2026 race is complete.",
    "exhibitorDeadline": "Not applicable to the race listing.",
    "speakerDeadline": "Not applicable.",
    "visaRelevance": "The 2026 race is complete. International teams should use the organizer's current documentation for future editions.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "Beijing humanoid robot half marathon 2026",
      "Yizhuang humanoid marathon",
      "Lightning humanoid robot",
      "China humanoid competition",
      "humanoid robot race"
    ]
  },
  {
    "id": "humanoids-summit-tokyo-2026",
    "name": "Humanoids Summit Tokyo 2026",
    "slug": "humanoids-summit-tokyo-2026",
    "eventType": "Summit",
    "category": "Humanoid Robots",
    "country": "Japan",
    "city": "Tokyo",
    "region": "Japan",
    "dateStart": "2026-05-28",
    "dateEnd": "2026-05-29",
    "month": "May 2026",
    "venue": "Takanawa Gateway Convention Center",
    "website": "https://humanoidssummit.com/agenda-2",
    "source": "Official Humanoids Summit website",
    "lastChecked": "September 3, 2026",
    "description": "The Tokyo edition of Humanoids Summit brought humanoid developers, researchers and investors together for two days focused on deployment, dexterity, interaction and commercialization. Hiroshi Ishiguro opened the program with a keynote on humanoids, interaction and real world deployment.",
    "audience": [
      "humanoid robot companies",
      "researchers",
      "investors",
      "robotics engineers",
      "technology buyers"
    ],
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "dexterous manipulation",
      "human robot interaction",
      "deployment",
      "robot hardware"
    ],
    "organizers": ["Humanoids Summit"],
    "verifiedFacts": [
      "The Tokyo program ran May 28 and 29, 2026 at Takanawa Gateway Convention Center.",
      "Hiroshi Ishiguro of Osaka University and ATR delivered the opening keynote.",
      "Official agenda sessions covered dexterity for Physical AI, humanoid deployment, robot character platforms and commercialization."
    ],
    "featuredRobots": ["Geminoid android robot from Hiroshi Ishiguro's research program"],
    "technologyHighlights": [
      "dexterous manipulation",
      "human robot interaction",
      "Physical AI",
      "real world deployment"
    ],
    "officialLinks": [
      { "label": "Official Tokyo agenda", "url": "https://humanoidssummit.com/agenda-2" },
      { "label": "Official attendee information", "url": "https://humanoidssummit.com/attendee-faqs" }
    ],
    "whyItMatters": "The Tokyo program connects Japan's long running humanoid research base with newer Physical AI companies and deployment discussions.",
    "bestFor": [
      "Japan humanoid robotics",
      "Physical AI",
      "dexterous manipulation",
      "industry networking"
    ],
    "priceRange": "Check the official event archive for ticket information.",
    "deadline": "The 2026 Tokyo edition is complete.",
    "applicationDeadline": "The 2026 Tokyo edition is complete.",
    "exhibitorDeadline": "The 2026 Tokyo edition is complete.",
    "speakerDeadline": "The 2026 Tokyo edition is complete.",
    "visaRelevance": "The 2026 Tokyo edition is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "Humanoids Summit Tokyo 2026",
      "Japan humanoid conference",
      "Physical AI Tokyo",
      "humanoid robotics summit Japan"
    ]
  },
  {
    "id": "robocup-2026-incheon",
    "name": "RoboCup 2026 Incheon",
    "slug": "robocup-2026-incheon",
    "eventType": "Competition",
    "category": "Robotics Competitions",
    "country": "South Korea",
    "city": "Incheon",
    "region": "South Korea",
    "dateStart": "2026-06-30",
    "dateEnd": "2026-07-06",
    "month": "June and July 2026",
    "venue": "Songdo Convensia",
    "website": "https://2026.robocup.org/",
    "source": "RoboCup Federation and RoboCup 2026 Incheon official websites",
    "lastChecked": "September 3, 2026",
    "description": "RoboCup 2026 brought the international robotics competition to South Korea for the first time. The federation expected more than 3,000 competitors, researchers, students and professionals plus 15,000 visitors at Songdo Convensia.",
    "audience": [
      "robotics researchers",
      "university teams",
      "student teams",
      "humanoid developers",
      "robot learning researchers"
    ],
    "mainTopics": [
      "humanoid soccer",
      "autonomous robots",
      "robot perception",
      "locomotion",
      "multi robot coordination",
      "domestic service robotics",
      "rescue robotics"
    ],
    "organizers": ["RoboCup Federation", "RoboCup 2026 Incheon Organizing Committee"],
    "verifiedFacts": [
      "The federation listed the full event window as June 30 through July 6, 2026 at Songdo Convensia.",
      "The public competition program ran July 2 through July 6. The local organizer stated that detailed match schedules were confirmed one day in advance.",
      "The new Humanoid Soccer League combined the former Humanoid League and Standard Platform League for 2026.",
      "Humanoid Soccer League robots competed autonomously in soccer matches and technical challenges across small, middle and large divisions."
    ],
    "technologyHighlights": [
      "autonomous perception",
      "humanoid locomotion",
      "learning",
      "behavior control",
      "multi robot coordination"
    ],
    "officialLinks": [
      { "label": "RoboCup Federation event page", "url": "https://robocup.org/events/80" },
      { "label": "Official 2026 schedule", "url": "https://2026.robocup.org/%EC%9D%BC%EC%A0%95/" },
      { "label": "Humanoid Soccer League announcement", "url": "https://www.robocup.org/news/187" }
    ],
    "whyItMatters": "RoboCup provides repeated public benchmarks for perception, locomotion, decision making and coordination under competition rules rather than isolated product presentations.",
    "bestFor": [
      "humanoid soccer",
      "university robotics",
      "autonomous robotics",
      "robot learning"
    ],
    "priceRange": "Check the official event archive.",
    "deadline": "The 2026 competition is complete.",
    "applicationDeadline": "The 2026 competition is complete.",
    "exhibitorDeadline": "The 2026 competition is complete.",
    "speakerDeadline": "The 2026 symposium is complete.",
    "visaRelevance": "The 2026 competition is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "RoboCup 2026 Incheon",
      "RoboCup humanoid soccer 2026",
      "humanoid robot competition",
      "robot soccer competition",
      "autonomous humanoid robots"
    ]
  },
  {
    "id": "waic-2026-shanghai",
    "name": "World Artificial Intelligence Conference 2026",
    "originalName": "2026世界人工智能大会暨人工智能全球治理高级别会议",
    "officialEnglishName": "2026 World Artificial Intelligence Conference and High-Level Meeting on Global AI Governance",
    "slug": "waic-2026-shanghai",
    "eventType": "Conference and exhibition",
    "category": "Research Conferences",
    "country": "China",
    "city": "Shanghai",
    "region": "China",
    "dateStart": "2026-07-17",
    "dateEnd": "2026-07-20",
    "month": "July 2026",
    "venue": "Shanghai Expo Centre, Shanghai World Expo Exhibition and Convention Center, Zhangjiang Science Hall and West Bund International Convention and Exhibition Center",
    "website": "https://www.worldaic.com.cn/",
    "source": "Shanghai Municipal Government official WAIC coverage",
    "lastChecked": "September 3, 2026",
    "description": "WAIC 2026 combined more than 140 forums with an exhibition exceeding 100,000 square meters. More than 1,100 companies showed over 3,000 exhibits and more than 300 products made global debuts. Embodied AI was one of the event's two major technology tracks with more than 200 companies in that segment.",
    "audience": [
      "AI researchers",
      "embodied AI teams",
      "robotics companies",
      "startups",
      "investors",
      "policy teams"
    ],
    "mainTopics": [
      "embodied AI",
      "Physical AI",
      "foundation models",
      "AI agents",
      "humanoid robots",
      "robot learning",
      "AI governance"
    ],
    "organizers": [
      "Ministry of Foreign Affairs of the People's Republic of China",
      "National Development and Reform Commission",
      "Ministry of Industry and Information Technology",
      "Ministry of Education",
      "Ministry of Science and Technology",
      "State-owned Assets Supervision and Administration Commission of the State Council",
      "Cyberspace Administration of China",
      "Chinese Academy of Sciences",
      "China Association for Science and Technology",
      "Shanghai Municipal People's Government"
    ],
    "verifiedFacts": [
      "The conference ran July 17 through July 20, 2026 across the Expo area, Zhangjiang and West Bund.",
      "The program included more than 140 forums and brought together more than 1,400 Chinese and international guests.",
      "The exhibition exceeded 100,000 square meters with more than 1,100 companies and more than 3,000 exhibits.",
      "Shanghai reported that embodied AI and intelligent computing each brought together more than 200 companies.",
      "A Shanghai government visitor guide described more than 300 robots working in dynamic manufacturing, daily-life and entertainment scenarios in one exhibition zone.",
      "Post-event official reporting counted representatives from 102 countries and international organizations and 1,568 experts."
    ],
    "featuredRobots": [
      "Humanoid and embodied AI systems shown in the Model Era, City of Partners exhibition zone"
    ],
    "technologyHighlights": [
      "embodied AI",
      "robot foundation models",
      "robot learning",
      "AI agents",
      "intelligent computing"
    ],
    "officialLinks": [
      { "label": "Shanghai official WAIC preview", "url": "https://english.shanghai.gov.cn/en-Events/20260624/9cc202d708504b56ba32f70fbd61ef79.html" },
      { "label": "Shanghai government press conference", "url": "https://www.shanghai.gov.cn/nw12344/20260707/deee99228f02433e9b0fb8f9447e8b34.html" },
      { "label": "Shanghai official exhibition highlights", "url": "https://english.shanghai.gov.cn/en-ParticipateExplore/20260717/36193160d9d94efb9c0aa5fa4fbed5fd.html" }
    ],
    "whyItMatters": "WAIC is broader than robotics, but its embodied AI track provides a dense view of Chinese robot models, hardware, deployment scenarios and startup activity in one Shanghai program.",
    "bestFor": [
      "embodied AI",
      "Physical AI",
      "China AI robotics",
      "robot foundation models"
    ],
    "priceRange": "Check the official event archive.",
    "deadline": "The 2026 conference is complete.",
    "applicationDeadline": "The 2026 conference is complete.",
    "exhibitorDeadline": "The 2026 conference is complete.",
    "speakerDeadline": "The 2026 conference is complete.",
    "visaRelevance": "The 2026 conference is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "WAIC 2026 robotics",
      "World Artificial Intelligence Conference 2026",
      "embodied AI Shanghai",
      "Physical AI China",
      "humanoid robots WAIC"
    ]
  },
  {
    "id": "huroc-expo-2026-tokyo",
    "name": "HuRoC EXPO 2026",
    "originalName": "HuRoC EXPO 2026",
    "slug": "huroc-expo-2026-tokyo",
    "eventType": "Exhibition",
    "category": "Humanoid Robots",
    "country": "Japan",
    "city": "Tokyo",
    "region": "Japan",
    "dateStart": "2026-07-17",
    "dateEnd": "2026-07-17",
    "month": "July 2026",
    "venue": "Ota City Industrial Plaza PiO, Main Exhibition Hall",
    "website": "https://huroc-expo.jp/",
    "source": "Official HuRoC and HuRoC EXPO websites",
    "lastChecked": "September 3, 2026",
    "description": "A one day Tokyo event focused on how humanoid robots can be tested and integrated into society. HuRoC brings developers, companies, universities, government and local communities into shared prototyping and field validation work.",
    "audience": [
      "humanoid developers",
      "universities",
      "manufacturers",
      "local government",
      "robotics researchers"
    ],
    "mainTopics": [
      "humanoid robots",
      "social deployment",
      "field testing",
      "robotics prototyping",
      "AI control"
    ],
    "organizers": ["HuRoC Executive Committee"],
    "coOrganizers": ["Prime Life Technologies Co., Ltd."],
    "verifiedFacts": [
      "HuRoC EXPO 2026 ran from 10:00 to 17:00 on July 17, 2026.",
      "The venue was the Main Exhibition Hall at Ota City Industrial Plaza PiO near Keikyu Kamata Station.",
      "The official event material listed HuRoC partner companies, universities, research institutions, robot development teams and Ota manufacturing companies as exhibitor groups."
    ],
    "technologyHighlights": [
      "humanoid prototyping",
      "AI control",
      "field validation",
      "human robot coexistence"
    ],
    "officialLinks": [
      { "label": "Official HuRoC EXPO site", "url": "https://huroc-expo.jp/" },
      { "label": "Official HuRoC community site", "url": "https://huroc.org/" }
    ],
    "whyItMatters": "HuRoC is useful for tracking Japan's community scale humanoid testing and the practical questions around introducing robots into manufacturing, housing, education and public life.",
    "bestFor": [
      "Japan humanoid ecosystem",
      "field validation",
      "human robot interaction",
      "robot prototyping"
    ],
    "priceRange": "Free with advance registration according to the official event material.",
    "deadline": "The 2026 event is complete.",
    "applicationDeadline": "The 2026 event is complete.",
    "exhibitorDeadline": "The 2026 event is complete.",
    "speakerDeadline": "The 2026 event is complete.",
    "visaRelevance": "The 2026 event is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "HuRoC EXPO 2026",
      "Tokyo humanoid robot event",
      "Japan humanoid robots",
      "humanoid robotics exhibition Japan"
    ]
  },
  {
    "id": "china-humanoid-robot-ecology-conference-2026",
    "name": "China Humanoid Robot Ecology Conference & Expo 2026",
    "originalName": "2026人形机器人生态大会",
    "officialEnglishName": "China Humanoid Robot Ecology Conference & Expo",
    "slug": "china-humanoid-robot-ecology-conference-2026",
    "eventType": "Conference and exhibition",
    "category": "Humanoid Robots",
    "country": "China",
    "city": "Shanghai",
    "region": "China",
    "dateStart": "2026-04-17",
    "dateEnd": "2026-04-19",
    "month": "April 2026",
    "venue": "Shanghai Auto Expo Center",
    "website": "https://www.chrec.cn/",
    "source": "Official China Humanoid Robot Ecology Conference & Expo website",
    "lastChecked": "September 3, 2026",
    "description": "A Shanghai conference and exhibition dedicated to the humanoid robotics ecosystem. The official program combined main forums, breakout sessions, exhibition activity, competitions, education and industry networking across three days.",
    "audience": [
      "humanoid robot companies",
      "robot component suppliers",
      "researchers",
      "universities",
      "investors",
      "industrial users"
    ],
    "mainTopics": [
      "humanoid robots",
      "robot components",
      "embodied intelligence",
      "locomotion",
      "manipulation",
      "industry ecosystem"
    ],
    "organizers": ["China Robotics Network"],
    "verifiedFacts": [
      "The 2026 event ran April 17 through April 19 at Shanghai Auto Expo Center.",
      "The organizer states that the conference series was launched in 2024 and maintains earlier event history for 2024 and 2025.",
      "The published three-day schedule included opening remarks, main forums, breakout forums and a concurrent exhibition.",
      "Published speakers included Junhao Chu, Lining Sun, Jie Zhao, Tianmiao Wang, Leju Robotics founder Xiaokun Leng and Unitree cofounder Li Chen."
    ],
    "technologyHighlights": [
      "humanoid hardware",
      "embodied intelligence",
      "robot components",
      "locomotion",
      "manipulation"
    ],
    "officialLinks": [
      { "label": "Official conference site", "url": "https://www.chrec.cn/" },
      { "label": "Official English event page", "url": "https://www.chrec.cn/index.php?a=index&c=Lists&m=home&tid=13" }
    ],
    "whyItMatters": "The event is narrowly focused on the Chinese humanoid supply chain and gives component companies, robot makers and university researchers a shared forum outside broader automation exhibitions.",
    "bestFor": [
      "China humanoid ecosystem",
      "robot components",
      "embodied intelligence",
      "supplier discovery"
    ],
    "priceRange": "Check the official event archive.",
    "deadline": "The 2026 edition is complete.",
    "applicationDeadline": "The 2026 edition is complete.",
    "exhibitorDeadline": "The 2026 edition is complete.",
    "speakerDeadline": "The 2026 edition is complete.",
    "visaRelevance": "The 2026 edition is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "China Humanoid Robot Ecology Conference 2026",
      "2026人形机器人生态大会",
      "Shanghai humanoid robot conference",
      "China humanoid robotics exhibition"
    ]
  },
  {
    "id": "ieee-case-2026-shenyang",
    "name": "IEEE CASE 2026",
    "slug": "ieee-case-2026-shenyang",
    "category": "Research Conferences",
    "country": "China",
    "city": "Shenyang",
    "region": "China",
    "dateStart": "2026-08-17",
    "dateEnd": "2026-08-21",
    "month": "August 2026",
    "venue": "Shenyang, Liaoning, China",
    "website": "https://www.ieee-ras.org/conferences-workshops/fully-sponsored/case/",
    "source": "IEEE Robotics and Automation Society official event page",
    "lastChecked": "August 4, 2026",
    "description": "A research conference on automation science and engineering, smart industry, production systems, optimization, industrial AI and autonomous systems.",
    "audience": [
      "researchers",
      "automation engineers",
      "industrial AI teams",
      "PhD students",
      "manufacturing R&D"
    ],
    "mainTopics": [
      "automation science",
      "smart industry",
      "industrial AI",
      "production optimization",
      "autonomous systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "research papers",
      "industrial AI",
      "automation systems",
      "China robotics research"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to China; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "IEEE CASE 2026",
      "robotics event 2026",
      "China robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "world-robot-conference-2026-beijing",
    "name": "World Robot Conference 2026",
    "originalName": "2026世界机器人大会",
    "officialEnglishName": "World Robot Conference 2026",
    "slug": "world-robot-conference-2026-beijing",
    "eventType": "Conference, exhibition and competition",
    "category": "Humanoid Robots",
    "country": "China",
    "city": "Beijing",
    "region": "China",
    "dateStart": "2026-08-19",
    "dateEnd": "2026-08-23",
    "month": "August 2026",
    "venue": "Beijing Beiren Yichuang International Convention and Exhibition Center",
    "website": "https://www.worldrobotconference.com/en/",
    "source": "Official World Robot Conference website and WRC SARA program",
    "lastChecked": "September 3, 2026",
    "description": "China’s large robotics conference, exhibition and competition program, with humanoid robots, embodied intelligence, industrial robots, service robots, components and application demonstrations. The completed 2026 edition reported 373 exhibitors, more than 3,000 products, 311 debut products, seven main forums, 71 concurrent activities and 557,000 on-site attendances.",
    "audience": [
      "robot manufacturers",
      "humanoid teams",
      "researchers",
      "investors",
      "media creators"
    ],
    "mainTopics": [
      "humanoid robots",
      "embodied intelligence",
      "industrial robots",
      "service robots",
      "robot components",
      "robot competitions"
    ],
    "organizers": [
      "Chinese Institute of Electronics",
      "World Robot Cooperation Organization"
    ],
    "verifiedFacts": [
      "The 2026 event ran August 19 through August 23 from 09:00 to 17:00 at Beijing Beiren Yichuang International Convention and Exhibition Center in Beijing E-Town.",
      "The official closing report counted 373 exhibitors, more than 3,000 products and 311 debut products.",
      "The conference program included seven main forums, 71 concurrent activities and more than 1,000 experts from China and overseas.",
      "Thirty international institutions and 40 overseas companies participated. Official reporting counted more than 10,000 foreign visitors and 557,000 on-site attendances."
    ],
    "featuredRobots": [
      "Tiangong Omni from Beijing Humanoid Robot Innovation Center",
      "Pelican-Unify embodied intelligence platform",
      "Humanoid and specialized robots from Chinese and international exhibitors"
    ],
    "technologyHighlights": [
      "humanoid locomotion",
      "embodied intelligence",
      "world models",
      "manipulation",
      "robot components"
    ],
    "officialLinks": [
      { "label": "Official WRC website", "url": "https://www.worldrobotconference.com/en/" },
      { "label": "Official WRC closing report", "url": "https://www.worldrobotconference.com/news/3616.html" },
      { "label": "Official WRC venue page", "url": "https://www.worldrobotconference.com/en/sara/about/venue/" }
    ],
    "whyItMatters": "WRC is one of the clearest places to compare China’s robot manufacturers, component suppliers, research programs and deployment claims in the same week.",
    "bestFor": [
      "humanoid robot launches",
      "China robotics market",
      "supplier discovery",
      "technical demonstrations"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "The 2026 edition is complete. Use the official event archive for program and result material.",
    "applicationDeadline": "The 2026 edition is complete.",
    "exhibitorDeadline": "The 2026 edition is complete.",
    "speakerDeadline": "The 2026 edition is complete.",
    "visaRelevance": "The 2026 edition is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "World Robot Conference 2026",
      "WRC Beijing 2026",
      "China humanoid robot exhibition",
      "embodied intelligence China",
      "physical AI event Beijing"
    ]
  },
  {
    "id": "world-humanoid-robot-games-2026-beijing",
    "name": "World Humanoid Robot Games 2026",
    "slug": "world-humanoid-robot-games-2026-beijing",
    "eventType": "Competition",
    "category": "Humanoid Robots",
    "country": "China",
    "city": "Beijing",
    "region": "China",
    "dateStart": "2026-08-22",
    "dateEnd": "2026-08-26",
    "month": "August 2026",
    "venue": "National Speed Skating Oval (Ice Ribbon)",
    "website": "https://www.whrgoc.com/",
    "source": "Beijing Municipal Government press conference and official World Humanoid Robot Games website",
    "lastChecked": "September 3, 2026",
    "description": "The second World Humanoid Robot Games brings 2,056 robots and 666 teams from 16 countries across six continents to Beijing for 51 events and 1,301 matches over five days.",
    "audience": [
      "humanoid robot companies",
      "robotics researchers",
      "universities",
      "physical AI teams",
      "robotics media",
      "investors"
    ],
    "mainTopics": [
      "humanoid robots",
      "robot athletics",
      "autonomous running",
      "robot football",
      "dexterous manipulation",
      "industrial scenarios",
      "home service",
      "emergency rescue"
    ],
    "originalName": "第二届世界人形机器人运动会",
    "organizers": [
      "People's Government of Beijing Municipality",
      "China Media Group",
      "World Robot Cooperation Organization",
      "RoboCup Asia-Pacific Confederation Board of Trustees"
    ],
    "verifiedFacts": [
      "The second World Humanoid Robot Games ran for five competition days from August 22 through August 26, 2026.",
      "The final field included 2,056 robots and 666 teams from 16 countries across six continents.",
      "The program contained 51 events and 1,301 matches, including 21 scenario events.",
      "Tiangong Ultra completed the 100 m final in 8.64 seconds on August 26.",
      "The official competition rules required autonomous operation in competitive events except the 100 m obstacle and 400 m obstacle races. Scenario events could use teleoperation with a lower scoring coefficient."
    ],
    "technologyHighlights": [
      "biped locomotion",
      "balance recovery",
      "dexterous manipulation",
      "robot football coordination",
      "embodied AI",
      "teleoperation where permitted"
    ],
    "officialLinks": [
      { "label": "Official World Humanoid Robot Games site", "url": "https://www.whrgoc.com/" },
      { "label": "Beijing official closing report", "url": "https://www.beijing.gov.cn/fuwu/lqfw/gggs/202608/t20260827_4838925.html" }
    ],
    "whyItMatters": "The field is large enough to compare locomotion, recovery, manipulation, multi-robot coordination and event-specific autonomy across repeated competition rather than one selected company demo.",
    "bestFor": [
      "humanoid robot benchmarking",
      "Physical AI",
      "embodied AI",
      "dexterous hands",
      "autonomy and recovery",
      "China humanoid ecosystem"
    ],
    "priceRange": "RMB 98–670 depending on session and seating.",
    "deadline": "The 2026 competition is complete. Use the official event archive for results and competition material.",
    "applicationDeadline": "The 2026 competition is complete.",
    "exhibitorDeadline": "Not applicable to the competition listing.",
    "speakerDeadline": "Not applicable.",
    "visaRelevance": "The 2026 competition is complete.",
    "status": "Completed",
    "statusTone": "past",
    "seoKeywords": [
      "World Humanoid Robot Games 2026",
      "World Humanoid Robot Games 2026 schedule",
      "Beijing humanoid robot games",
      "robot game 2026",
      "robot Olympics 2026",
      "2056 humanoid robots",
      "666 teams robotics",
      "1301 robot matches",
      "physical AI event Beijing"
    ],
    "articlePath": "/robotics-news/world-humanoid-robot-games-2026"
  },
  {
    "id": "ieee-ro-man-2026-kitakyushu",
    "name": "IEEE RO-MAN 2026",
    "slug": "ieee-ro-man-2026-kitakyushu",
    "eventType": "Conference",
    "category": "Human Robot Interaction",
    "country": "Japan",
    "city": "Kitakyushu",
    "region": "Japan",
    "dateStart": "2026-08-24",
    "dateEnd": "2026-08-28",
    "month": "August 2026",
    "venue": "Kitakyushu International Convention Zone",
    "website": "https://www.ieee-ras.org/event/2026-ieee-35th-international-conference-on-robot-and-human-interactive-communication-ro-man-72286/",
    "source": "IEEE Robotics and Automation Society official event page",
    "lastChecked": "August 4, 2026",
    "description": "A specialist conference on robot and human interactive communication, social robotics, assistive systems, trust, teleoperation and embodied interaction.",
    "audience": [
      "HRI researchers",
      "robot designers",
      "PhD students",
      "assistive robotics teams",
      "social robotics startups"
    ],
    "mainTopics": [
      "human-robot interaction",
      "social robotics",
      "assistive robots",
      "teleoperation",
      "robot communication",
      "embodied AI"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "human-robot interaction research",
      "social robotics",
      "assistive systems",
      "technical workshops"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "IEEE RO-MAN 2026",
      "robotics event 2026",
      "Japan robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "all-about-automation-zurich-2026",
    "name": "All About Automation Zürich 2026",
    "slug": "all-about-automation-zurich-2026",
    "category": "Industrial Automation",
    "country": "Switzerland",
    "city": "Zurich",
    "region": "Europe",
    "dateStart": "2026-08-26",
    "dateEnd": "2026-08-27",
    "month": "August 2026",
    "venue": "Zurich, Switzerland",
    "website": "https://www.allaboutautomation.de/en/",
    "source": "Official All About Automation website",
    "lastChecked": "August 4, 2026",
    "description": "A regional automation exhibition for industrial robotics, control systems, sensors, drives, machine vision, integration and smart manufacturing.",
    "audience": [
      "manufacturers",
      "automation engineers",
      "integrators",
      "component suppliers",
      "industrial buyers"
    ],
    "mainTopics": [
      "industrial robots",
      "automation systems",
      "machine vision",
      "drives",
      "sensors",
      "system integration"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Swiss automation suppliers",
      "industrial robotics",
      "system integration",
      "regional business contacts"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Switzerland; use the organizer’s current registration and invitation-document process.",
    "status": "Registration and exhibitor information available",
    "statusTone": "open",
    "seoKeywords": [
      "All About Automation Zürich 2026",
      "robotics event 2026",
      "Switzerland robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "commercial-uav-expo-2026",
    "name": "Commercial UAV Expo 2026",
    "slug": "commercial-uav-expo-2026",
    "category": "Drone Robotics",
    "country": "United States",
    "city": "Las Vegas",
    "region": "United States",
    "dateStart": "2026-09-01",
    "dateEnd": "2026-09-03",
    "month": "September 2026",
    "venue": "Caesars Forum, Las Vegas",
    "website": "https://www.expouav.com/",
    "source": "Official Commercial UAV Expo website",
    "lastChecked": "August 4, 2026",
    "description": "A commercial uncrewed systems conference and trade show covering aerial robotics, autonomy, sensors, mapping, inspection, public safety and enterprise drone operations.",
    "audience": [
      "drone companies",
      "field robotics teams",
      "surveying firms",
      "public safety teams",
      "technology buyers"
    ],
    "mainTopics": [
      "aerial robotics",
      "autonomous drones",
      "sensors",
      "mapping",
      "inspection robots",
      "uncrewed systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "commercial drones",
      "field robotics",
      "sensor suppliers",
      "enterprise deployment"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to United States; use the organizer’s current registration and invitation-document process.",
    "status": "Registration open",
    "statusTone": "open",
    "seoKeywords": [
      "Commercial UAV Expo 2026",
      "robotics event 2026",
      "United States robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "factory-innovation-week-september-2026",
    "name": "Factory Innovation Week September 2026",
    "slug": "factory-innovation-week-september-2026",
    "category": "Physical AI",
    "country": "Japan",
    "city": "Chiba",
    "region": "Japan",
    "dateStart": "2026-09-09",
    "dateEnd": "2026-09-11",
    "month": "September 2026",
    "venue": "Makuhari Messe, Chiba, Japan",
    "website": "https://www.fiweek.jp/autumn/en-gb.html",
    "source": "Official RX Japan Factory Innovation Week website",
    "lastChecked": "August 4, 2026",
    "description": "A five-show manufacturing platform that includes RoboDEX for robotics and automation and Smart Factory Expo for AI, IoT and factory digitalization.",
    "audience": [
      "manufacturers",
      "robot suppliers",
      "factory engineers",
      "integrators",
      "industrial software teams"
    ],
    "mainTopics": [
      "RoboDEX",
      "industrial robotics",
      "factory automation",
      "physical AI",
      "machine vision",
      "smart factory"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Japan robotics suppliers",
      "RoboDEX",
      "physical AI hardware",
      "factory automation"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Visitor registration available",
    "statusTone": "open",
    "seoKeywords": [
      "Factory Innovation Week September 2026",
      "robotics event 2026",
      "Japan robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "humanoid-robots-summit-europe-2026",
    "name": "Humanoid Robots Summit Europe 2026",
    "slug": "humanoid-robots-summit-europe-2026",
    "eventType": "Summit",
    "category": "Humanoid Robots",
    "country": "Germany",
    "city": "Stuttgart",
    "region": "Europe",
    "dateStart": "2026-09-09",
    "dateEnd": "2026-09-11",
    "month": "September 2026",
    "venue": "Stuttgart, Germany",
    "website": "https://acgrobot.com/",
    "source": "Official Humanoid Robots Summit Europe website",
    "lastChecked": "August 4, 2026",
    "description": "A dedicated European industry summit focused on humanoid robot hardware, actuators, dexterous hands, perception, embodied AI, manufacturing and deployment.",
    "audience": [
      "humanoid companies",
      "component suppliers",
      "investors",
      "industrial adopters",
      "robotics media"
    ],
    "mainTopics": [
      "humanoid robots",
      "embodied AI",
      "actuators",
      "dexterous hands",
      "robot perception",
      "manufacturing"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "humanoid market analysis",
      "component sourcing",
      "company networking",
      "physical AI"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Germany; use the organizer’s current registration and invitation-document process.",
    "status": "Registration open",
    "statusTone": "open",
    "seoKeywords": [
      "Humanoid Robots Summit Europe 2026",
      "humanoid robot conference Germany",
      "physical AI Europe",
      "embodied AI event Stuttgart"
    ]
  },
  {
    "id": "cemat-russia-2026",
    "name": "CeMAT Russia 2026",
    "slug": "cemat-russia-2026",
    "category": "Warehouse Robotics",
    "country": "Russia",
    "city": "Moscow",
    "region": "Europe",
    "dateStart": "2026-09-15",
    "dateEnd": "2026-09-17",
    "month": "September 2026",
    "venue": "Crocus Expo, Pavilion 1, Moscow",
    "website": "https://www.cemat-russia.ru/en/",
    "source": "Official CeMAT Russia website",
    "lastChecked": "August 4, 2026",
    "description": "An exhibition for warehouse and industrial logistics machinery, automation tools, robotics, material handling and intralogistics systems.",
    "audience": [
      "warehouse operators",
      "logistics companies",
      "robot suppliers",
      "integrators",
      "industrial buyers"
    ],
    "mainTopics": [
      "warehouse robots",
      "intralogistics",
      "AMR",
      "AGV",
      "material handling",
      "industrial automation"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "warehouse robotics",
      "Russian automation market",
      "intralogistics suppliers",
      "AMR and AGV"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Russia; use the organizer’s current registration and invitation-document process.",
    "status": "Visitor and booth registration available",
    "statusTone": "open",
    "seoKeywords": [
      "CeMAT Russia 2026",
      "robotics event 2026",
      "Russia robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "futurepulse-2026-eindhoven",
    "name": "FuturePulse 2026 Dutch Robotics Conference",
    "slug": "futurepulse-2026-eindhoven",
    "category": "AI Robotics",
    "country": "Netherlands",
    "city": "Eindhoven",
    "region": "Europe",
    "dateStart": "2026-09-15",
    "dateEnd": "2026-09-16",
    "month": "September 2026",
    "venue": "Eindhoven, Netherlands",
    "website": "https://ifr.org/event/futurepulse",
    "source": "International Federation of Robotics event page",
    "lastChecked": "August 4, 2026",
    "description": "The Dutch robotics conference covering how robots and AI are being used in healthcare, industry, education and daily life.",
    "audience": [
      "robotics companies",
      "researchers",
      "industrial adopters",
      "healthcare innovators",
      "policy teams"
    ],
    "mainTopics": [
      "AI robotics",
      "healthcare robots",
      "industrial robots",
      "education robotics",
      "robot adoption"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Dutch robotics ecosystem",
      "AI robotics applications",
      "cross-sector networking",
      "European partnerships"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Netherlands; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "FuturePulse 2026 Dutch Robotics Conference",
      "robotics event 2026",
      "Netherlands robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "sido-lyon-2026",
    "name": "SIDO Lyon 2026",
    "slug": "sido-lyon-2026",
    "category": "AI Robotics",
    "country": "France",
    "city": "Lyon",
    "region": "Europe",
    "dateStart": "2026-09-16",
    "dateEnd": "2026-09-17",
    "month": "September 2026",
    "venue": "Cité Internationale de Lyon",
    "website": "https://www.sido-lyon.com/en/",
    "source": "Official SIDO Lyon website",
    "lastChecked": "August 4, 2026",
    "description": "A business technology event where IoT, artificial intelligence, robotics and XR are presented together for industrial transformation projects.",
    "audience": [
      "industrial decision-makers",
      "AI teams",
      "robotics startups",
      "integrators",
      "technology buyers"
    ],
    "mainTopics": [
      "AI",
      "robotics",
      "IoT",
      "XR",
      "industrial transformation",
      "edge systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "France robotics ecosystem",
      "industrial AI",
      "business partnerships",
      "technology sourcing"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to France; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "SIDO Lyon 2026",
      "robotics event 2026",
      "France robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "canadian-robotics-council-symposium-2026",
    "name": "Canadian Robotics Council Symposium 2026",
    "slug": "canadian-robotics-council-symposium-2026",
    "category": "Startup and Investor Events",
    "country": "Canada",
    "city": "Toronto",
    "region": "North America",
    "dateStart": "2026-09-21",
    "dateEnd": "2026-09-21",
    "month": "September 2026",
    "venue": "Downtown Toronto, Ontario",
    "website": "https://roboticscouncil.swoogo.com/symposium2026",
    "source": "Official Canadian Robotics Council symposium page",
    "lastChecked": "August 4, 2026",
    "description": "Canada’s national robotics gathering for companies, researchers, adopters, investors and government decision-makers.",
    "audience": [
      "robotics companies",
      "investors",
      "researchers",
      "industrial adopters",
      "policy leaders"
    ],
    "mainTopics": [
      "robotics commercialization",
      "robot adoption",
      "investment",
      "workforce",
      "Canadian robotics ecosystem"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Canada robotics network",
      "commercialization",
      "investment contacts",
      "policy discussion"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Canada; use the organizer’s current registration and invitation-document process.",
    "status": "Registration open",
    "statusTone": "open",
    "seoKeywords": [
      "Canadian Robotics Council Symposium 2026",
      "robotics event 2026",
      "Canada robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "roscon-2026-toronto",
    "name": "ROSCon Global 2026",
    "slug": "roscon-2026-toronto",
    "category": "Robotics Software",
    "country": "Canada",
    "city": "Toronto",
    "region": "North America",
    "dateStart": "2026-09-22",
    "dateEnd": "2026-09-24",
    "month": "September 2026",
    "venue": "Sheraton Centre Toronto Hotel",
    "website": "https://roscon.ros.org/",
    "source": "Official ROSCon Global website and 2026 sponsor prospectus",
    "lastChecked": "August 4, 2026",
    "description": "The global conference for Robot Operating System developers, maintainers and companies building production robotics software.",
    "audience": [
      "robotics software engineers",
      "ROS maintainers",
      "robot companies",
      "researchers",
      "developers"
    ],
    "mainTopics": [
      "ROS",
      "ROS 2",
      "robot software",
      "open-source robotics",
      "navigation",
      "developer tools"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "ROS 2 engineering",
      "open-source robotics",
      "developer networking",
      "production software"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Canada; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "ROSCon Global 2026",
      "robotics event 2026",
      "Canada robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "ieee-iros-2026-pittsburgh",
    "name": "IEEE/RSJ IROS 2026",
    "slug": "ieee-iros-2026-pittsburgh",
    "category": "Research Conferences",
    "country": "United States",
    "city": "Pittsburgh",
    "region": "United States",
    "dateStart": "2026-09-27",
    "dateEnd": "2026-10-01",
    "month": "September 2026",
    "venue": "David L. Lawrence Convention Center, Pittsburgh",
    "website": "https://2026.ieee-iros.org/",
    "source": "IEEE Robotics and Automation Society event record, IROS 2026 program announcement and official exhibit prospectus",
    "lastChecked": "September 30, 2026",
    "description": "IROS 2026 runs in Pittsburgh from September 27 through October 1, combining research sessions, workshops, competitions and an exhibit hall. The conference program announcement lists more than 1,900 papers, 19 keynote talks, 86 workshops and tutorials, 9 competitions and more than 170 exhibitors.",
    "audience": [
      "researchers",
      "PhD students",
      "robotics engineers",
      "R&D teams",
      "startup founders"
    ],
    "mainTopics": [
      "robot learning",
      "manipulation",
      "locomotion",
      "perception",
      "control",
      "intelligent robots"
    ],
    "verifiedFacts": [
      "IEEE RAS lists IROS 2026 for September 27 through October 1 at the David L. Lawrence Convention Center in Pittsburgh.",
      "The conference program announcement lists more than 1,900 papers, 19 keynote talks, 86 workshops and tutorials, 9 competitions and more than 170 exhibitors.",
      "The official exhibit prospectus lists exhibit hours through September 30, with the hall open 9:00 AM to 4:00 PM on the final exhibit day."
    ],
    "officialLinks": [
      { "label": "Official IROS 2026 website", "url": "https://2026.ieee-iros.org/" },
      { "label": "IEEE RAS event record", "url": "https://www.ieee-ras.org/event/2026-ieee-rsj-international-conference-on-intelligent-robots-and-systems-iros-61738/" },
      { "label": "Official exhibits and floor plan", "url": "https://iros.exhibitprospectus.com/" },
      { "label": "IEEE RAS events at IROS", "url": "https://www.ieee-ras.org/ieee-ras-events-at-iros/" }
    ],
    "whyItMatters": "The paper program and exhibit hall let visitors compare research methods with real robot hardware in the same venue. For humanoid and Physical AI coverage, this makes it possible to trace a claim from a paper or workshop to the platforms, sensors and compute shown on the exhibition floor.",
    "bestFor": [
      "research papers",
      "robot learning",
      "technical workshops",
      "global robotics networking"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "The exhibit hall closes September 30 at 4:00 PM. Conference sessions continue through October 1.",
    "applicationDeadline": "Paper submissions are closed for the 2026 conference.",
    "exhibitorDeadline": "The 2026 exhibition is already in progress.",
    "speakerDeadline": "The 2026 program is already in progress.",
    "visaRelevance": "High for international visitors traveling to United States; use the organizer’s current registration and invitation-document process.",
    "status": "Conference in progress",
    "statusTone": "open",
    "seoKeywords": [
      "IEEE/RSJ IROS 2026",
      "robotics event 2026",
      "United States robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "msv-brno-2026",
    "name": "MSV International Industrial Fair 2026",
    "slug": "msv-brno-2026",
    "category": "Smart Manufacturing",
    "country": "Czech Republic",
    "city": "Brno",
    "region": "Europe",
    "dateStart": "2026-10-06",
    "dateEnd": "2026-10-09",
    "month": "October 2026",
    "venue": "Brno Exhibition Centre",
    "website": "https://www.msvbrno.cz/",
    "source": "Official BVV / MSV website",
    "lastChecked": "August 4, 2026",
    "description": "Central Europe’s large industrial fair, including automation, robotics, digital manufacturing, machine tools and production technology.",
    "audience": [
      "manufacturers",
      "automation suppliers",
      "industrial buyers",
      "integrators",
      "technology media"
    ],
    "mainTopics": [
      "industrial automation",
      "robotics",
      "digital manufacturing",
      "machine tools",
      "AI manufacturing",
      "production systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Central European industry",
      "industrial robotics",
      "supplier discovery",
      "smart manufacturing"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Czech Republic; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "MSV International Industrial Fair 2026",
      "robotics event 2026",
      "Czech Republic robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "motek-2026-stuttgart",
    "name": "Motek 2026",
    "slug": "motek-2026-stuttgart",
    "category": "Industrial Automation",
    "country": "Germany",
    "city": "Stuttgart",
    "region": "Europe",
    "dateStart": "2026-10-06",
    "dateEnd": "2026-10-08",
    "month": "October 2026",
    "venue": "Messe Stuttgart",
    "website": "https://www.motek-messe.de/en/",
    "source": "Official Motek website",
    "lastChecked": "August 4, 2026",
    "description": "A production and assembly automation trade fair covering handling systems, industrial robotics, feeding technology, material flow and machine vision.",
    "audience": [
      "factory engineers",
      "integrators",
      "robot suppliers",
      "manufacturers",
      "industrial buyers"
    ],
    "mainTopics": [
      "assembly automation",
      "industrial robots",
      "handling technology",
      "material flow",
      "machine vision",
      "production systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "assembly automation",
      "robot integration",
      "factory hardware",
      "German suppliers"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Germany; use the organizer’s current registration and invitation-document process.",
    "status": "Tickets and exhibitor information available",
    "statusTone": "open",
    "seoKeywords": [
      "Motek 2026",
      "robotics event 2026",
      "Germany robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "bimu-2026-milan",
    "name": "35.BI-MU 2026",
    "slug": "bimu-2026-milan",
    "category": "Industrial Automation",
    "country": "Italy",
    "city": "Milan",
    "region": "Europe",
    "dateStart": "2026-10-13",
    "dateEnd": "2026-10-16",
    "month": "October 2026",
    "venue": "Fieramilano Rho",
    "website": "https://www.bimu.it/en/",
    "source": "Official BI-MU website",
    "lastChecked": "August 4, 2026",
    "description": "Italy’s biennial manufacturing exhibition for machine tools, robots, automation systems, digital manufacturing and enabling technologies.",
    "audience": [
      "manufacturers",
      "robot integrators",
      "machine builders",
      "industrial buyers",
      "component suppliers"
    ],
    "mainTopics": [
      "industrial robots",
      "automation systems",
      "digital manufacturing",
      "machine tools",
      "RobotHeart",
      "production technology"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Italian robotics market",
      "industrial automation",
      "RobotHeart area",
      "manufacturing suppliers"
    ],
    "priceRange": "Free personal entry pass available through the official website; check current conditions.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Italy; use the organizer’s current registration and invitation-document process.",
    "status": "Free visitor pass available",
    "statusTone": "open",
    "seoKeywords": [
      "35.BI-MU 2026",
      "robotics event 2026",
      "Italy robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "kyiv-technical-fair-2026",
    "name": "Kyiv Technical Fair 2026",
    "slug": "kyiv-technical-fair-2026",
    "category": "Industrial Automation",
    "country": "Ukraine",
    "city": "Kyiv",
    "region": "Europe",
    "dateStart": "2026-10-13",
    "dateEnd": "2026-10-15",
    "month": "October 2026",
    "venue": "International Exhibition Centre, Kyiv",
    "website": "https://www.iec-expo.com.ua/en/",
    "source": "Official International Exhibition Centre Kyiv calendar",
    "lastChecked": "August 4, 2026",
    "description": "An industrial technology fair covering machine building, drives, hydraulics, warehouse equipment and industrial automation.",
    "audience": [
      "Ukrainian manufacturers",
      "automation suppliers",
      "industrial engineers",
      "integrators",
      "technology buyers"
    ],
    "mainTopics": [
      "industrial automation",
      "drives",
      "warehouse equipment",
      "machine building",
      "control systems",
      "industrial safety"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Ukraine industrial technology",
      "automation suppliers",
      "regional partnerships",
      "manufacturing systems"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the organizer’s current security, access, registration and travel notices before making arrangements.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "International visitors should review current official travel and security guidance in addition to the organizer’s registration information.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "Kyiv Technical Fair 2026",
      "robotics event 2026",
      "Ukraine robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "robobusiness-2026",
    "name": "RoboBusiness 2026",
    "slug": "robobusiness-2026",
    "category": "Physical AI",
    "country": "United States",
    "city": "Santa Clara",
    "region": "United States",
    "dateStart": "2026-10-20",
    "dateEnd": "2026-10-21",
    "month": "October 2026",
    "venue": "Santa Clara Convention Center",
    "website": "https://www.robobusiness.com/",
    "source": "Official RoboBusiness schedule, tracks, pricing, FAQ and exhibit-floor pages",
    "lastChecked": "October 6, 2026",
    "description": "RoboBusiness 2026 runs October 20–21 at the Santa Clara Convention Center. Its conference tracks cover Physical AI, humanoids, field robotics, enabling technologies, robot design and deployment, alongside an expo floor with live systems and an Engineering Theater.",
    "audience": [
      "robot developers",
      "startup founders",
      "product engineers",
      "investors",
      "industrial adopters"
    ],
    "mainTopics": [
      "physical AI",
      "humanoid robots",
      "field robotics",
      "robot design",
      "sensors",
      "commercial deployment"
    ],
    "verifiedFacts": [
      "The official event site lists RoboBusiness for October 20–21, 2026 at the Santa Clara Convention Center.",
      "The 2026 program is organized around Physical AI, Enabling Technologies, Humanoids, Field Robotics, Business & Deployment, and Design & Development tracks.",
      "Current official pricing lists $720 for a full conference pass, $220 for student or academic access, and $120 for expo-only access.",
      "Official pages currently disagree on the October 20 exhibit-hall closing time: the schedule-at-a-glance page says 5:00 PM, while the exhibit-floor page and FAQ say 6:30 PM. Visitors should verify the final time before attending."
    ],
    "officialLinks": [
      {
        "label": "Official RoboBusiness website",
        "url": "https://www.robobusiness.com/"
      },
      {
        "label": "Conference tracks",
        "url": "https://www.robobusiness.com/tracks/"
      },
      {
        "label": "Schedule at a glance",
        "url": "https://www.robobusiness.com/schedule-at-a-glance/"
      },
      {
        "label": "Exhibit floor",
        "url": "https://www.robobusiness.com/exhibit-floor/"
      },
      {
        "label": "Pass pricing",
        "url": "https://www.robobusiness.com/pricing/"
      },
      {
        "label": "Official FAQ",
        "url": "https://www.robobusiness.com/faq/"
      }
    ],
    "whyItMatters": "The conference separates humanoids, Physical AI, engineering hardware and deployment into distinct tracks, while the expo floor provides a place to compare the systems discussed on stage with products and robot demonstrations from vendors.",
    "bestFor": [
      "commercial robotics",
      "humanoid industry",
      "physical AI",
      "startup and supplier networking"
    ],
    "priceRange": "$720 full conference, $220 student/academic and $120 expo-only at the rates checked September 30, 2026.",
    "deadline": "The official FAQ lists October 4 as the Hilton room-block deadline and says on-site registration is available. The pricing page says no refunds are issued after October 3.",
    "applicationDeadline": "Attendee registration remains available online and on site according to the official FAQ.",
    "exhibitorDeadline": "Exhibitor opportunities and floor-plan information remain on the official event site; availability can change as booths are booked.",
    "speakerDeadline": "The 2026 conference program is already published.",
    "visaRelevance": "The official FAQ states that visa letters are available for international attendees.",
    "status": "Registration open",
    "statusTone": "open",
    "seoKeywords": [
      "RoboBusiness 2026",
      "Physical AI Forum",
      "humanoid robotics event USA",
      "commercial robotics conference",
      "Santa Clara robotics expo"
    ]
  },
  {
    "id": "ieee-ssrr-2026-incheon",
    "name": "IEEE SSRR 2026",
    "slug": "ieee-ssrr-2026-incheon",
    "category": "Research Conferences",
    "country": "South Korea",
    "city": "Incheon",
    "region": "South Korea",
    "dateStart": "2026-11-02",
    "dateEnd": "2026-11-04",
    "month": "November 2026",
    "venue": "Inha University, Incheon",
    "website": "https://www.ssrr-ieee.org/",
    "source": "Official IEEE SSRR 2026 website",
    "lastChecked": "August 4, 2026",
    "description": "A field robotics conference focused on safety, security and rescue applications, with aerial, ground and marine robots, sensors, AI and extreme-environment testing.",
    "audience": [
      "field roboticists",
      "researchers",
      "emergency response teams",
      "public safety agencies",
      "PhD students"
    ],
    "mainTopics": [
      "rescue robots",
      "field robotics",
      "aerial robots",
      "marine robots",
      "computer vision",
      "extreme environments"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "rescue robotics",
      "field testing",
      "extreme environments",
      "research and practitioner exchange"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to South Korea; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "IEEE SSRR 2026",
      "robotics event 2026",
      "South Korea robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "autonomous-systems-robotics-expo-2026",
    "name": "Autonomous Systems & Robotics Expo 2026",
    "slug": "autonomous-systems-robotics-expo-2026",
    "category": "Warehouse Robotics",
    "country": "Poland",
    "city": "Warsaw",
    "region": "Europe",
    "dateStart": "2026-11-03",
    "dateEnd": "2026-11-05",
    "month": "November 2026",
    "venue": "Ptak Warsaw Expo, Nadarzyn",
    "website": "https://autonomoussystemsroboticsexpo.com/en/",
    "source": "Official Autonomous Systems & Robotics Expo website",
    "lastChecked": "August 4, 2026",
    "description": "A specialist B2B exhibition for mobile robotics, autonomous vehicles, drones, AMRs, AGVs, cobots, industrial robots, sensors and AI control systems.",
    "audience": [
      "robot manufacturers",
      "logistics operators",
      "automation engineers",
      "integrators",
      "industrial buyers"
    ],
    "mainTopics": [
      "AMR",
      "AGV",
      "cobots",
      "industrial robots",
      "autonomous vehicles",
      "drones",
      "AI control"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "mobile robotics",
      "autonomous systems",
      "Poland robotics market",
      "industrial and logistics deployment"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Poland; use the organizer’s current registration and invitation-document process.",
    "status": "Registration available",
    "statusTone": "open",
    "seoKeywords": [
      "Autonomous Systems & Robotics Expo 2026",
      "robotics event 2026",
      "Poland robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "robotworld-2026-korea",
    "name": "ROBOTWORLD 2026",
    "slug": "robotworld-2026-korea",
    "category": "Industrial Automation",
    "country": "South Korea",
    "city": "Goyang",
    "region": "South Korea",
    "dateStart": "2026-11-04",
    "dateEnd": "2026-11-07",
    "month": "November 2026",
    "venue": "KINTEX Exhibition Hall 1, Goyang",
    "website": "https://eng.robotworld.or.kr/",
    "source": "Official ROBOTWORLD website",
    "lastChecked": "August 4, 2026",
    "description": "South Korea’s major robotics exhibition and business program for industrial robots, service robots, robot components, automation and commercial applications.",
    "audience": [
      "robot manufacturers",
      "component suppliers",
      "industrial buyers",
      "researchers",
      "technology media"
    ],
    "mainTopics": [
      "industrial robots",
      "service robots",
      "robot components",
      "automation",
      "robot business",
      "AI robotics"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Korean robotics companies",
      "commercial robots",
      "component sourcing",
      "industry networking"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to South Korea; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "ROBOTWORLD 2026",
      "robotics event 2026",
      "South Korea robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "swiss-robotics-day-2026",
    "name": "Swiss Robotics Day 2026",
    "slug": "swiss-robotics-day-2026",
    "category": "AI Robotics",
    "country": "Switzerland",
    "city": "Zurich",
    "region": "Europe",
    "dateStart": "2026-11-13",
    "dateEnd": "2026-11-13",
    "month": "November 2026",
    "venue": "StageOne Event & Convention Center, Zurich",
    "website": "https://swissroboticsday.ch/",
    "source": "Official Swiss Robotics Day website",
    "lastChecked": "August 4, 2026",
    "description": "A national robotics exhibition and networking event connecting academia, industry, policymakers and innovators.",
    "audience": [
      "researchers",
      "robot companies",
      "startups",
      "policy teams",
      "industrial partners"
    ],
    "mainTopics": [
      "Swiss robotics",
      "robot research",
      "industrial robotics",
      "startups",
      "technology transfer"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Swiss robotics ecosystem",
      "research transfer",
      "startup networking",
      "robot demonstrations"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Switzerland; use the organizer’s current registration and invitation-document process.",
    "status": "Registration available",
    "statusTone": "open",
    "seoKeywords": [
      "Swiss Robotics Day 2026",
      "robotics event 2026",
      "Switzerland robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "iberian-robotics-conference-2026",
    "name": "9th Iberian Robotics Conference 2026",
    "slug": "iberian-robotics-conference-2026",
    "category": "Research Conferences",
    "country": "Spain",
    "city": "Barcelona",
    "region": "Europe",
    "dateStart": "2026-11-18",
    "dateEnd": "2026-11-20",
    "month": "November 2026",
    "venue": "UPC ETSEIB, Barcelona",
    "website": "https://robot2026.upc.edu/",
    "source": "IEEE Robotics and Automation Society official event page",
    "lastChecked": "August 4, 2026",
    "description": "An international robotics research conference covering artificial intelligence, machine learning, control and robotics applications.",
    "audience": [
      "researchers",
      "PhD students",
      "robotics engineers",
      "Iberian universities",
      "technology companies"
    ],
    "mainTopics": [
      "robotics research",
      "artificial intelligence",
      "machine learning",
      "control",
      "robot applications"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Iberian robotics research",
      "AI and control",
      "academic networking",
      "technical papers"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Spain; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "9th Iberian Robotics Conference 2026",
      "robotics event 2026",
      "Spain robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "russian-robotics-week-2026",
    "name": "Russian Robotics Week 2026",
    "slug": "russian-robotics-week-2026",
    "category": "AI Robotics",
    "country": "Russia",
    "city": "Saint Petersburg",
    "region": "Europe",
    "dateStart": "2026-11-18",
    "dateEnd": "2026-11-20",
    "month": "November 2026",
    "venue": "PetroCongress Center, Saint Petersburg",
    "website": "https://roboticsweek.ru/en/",
    "source": "Official Russian Robotics Week website",
    "lastChecked": "August 4, 2026",
    "description": "An international robotics forum with a robotics innovation exhibition, expert conference, workshops, vendor sessions and student skills competitions.",
    "audience": [
      "robot vendors",
      "integrators",
      "researchers",
      "industrial companies",
      "students"
    ],
    "mainTopics": [
      "industrial robotics",
      "robotics exhibition",
      "AI",
      "robot programming",
      "system integration",
      "robotics skills"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Russian robotics ecosystem",
      "industrial robotics",
      "vendor networking",
      "robotics demonstrations"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Russia; use the organizer’s current registration and invitation-document process.",
    "status": "Registration and participation information available",
    "statusTone": "open",
    "seoKeywords": [
      "Russian Robotics Week 2026",
      "robotics event 2026",
      "Russia robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "sps-2026-nuremberg",
    "name": "SPS 2026",
    "slug": "sps-2026-nuremberg",
    "category": "Industrial Automation",
    "country": "Germany",
    "city": "Nuremberg",
    "region": "Europe",
    "dateStart": "2026-11-24",
    "dateEnd": "2026-11-26",
    "month": "November 2026",
    "venue": "NürnbergMesse, Nuremberg",
    "website": "https://sps.mesago.com/nuernberg/en.html",
    "source": "Official SPS website",
    "lastChecked": "August 4, 2026",
    "description": "A large smart production solutions exhibition covering industrial automation, control, drives, sensors, software, machine vision and connected manufacturing.",
    "audience": [
      "automation engineers",
      "manufacturers",
      "component suppliers",
      "integrators",
      "industrial buyers"
    ],
    "mainTopics": [
      "industrial automation",
      "control systems",
      "drives",
      "sensors",
      "machine vision",
      "factory software"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "automation components",
      "control systems",
      "German suppliers",
      "smart manufacturing"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Germany; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "SPS 2026",
      "robotics event 2026",
      "Germany robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "factory-innovation-week-nagoya-2026",
    "name": "Factory Innovation Week Nagoya 2026",
    "slug": "factory-innovation-week-nagoya-2026",
    "category": "Physical AI",
    "country": "Japan",
    "city": "Tokoname",
    "region": "Japan",
    "dateStart": "2026-11-25",
    "dateEnd": "2026-11-27",
    "month": "November 2026",
    "venue": "Aichi Sky Expo, Japan",
    "website": "https://www.fiweek.jp/hub/en-gb.html",
    "source": "Official RX Japan Factory Innovation Week website",
    "lastChecked": "August 4, 2026",
    "description": "The Nagoya edition of Factory Innovation Week, including RoboDEX robotics and automation technologies and Smart Factory Expo.",
    "audience": [
      "manufacturers",
      "robot suppliers",
      "automotive production teams",
      "integrators",
      "industrial software companies"
    ],
    "mainTopics": [
      "RoboDEX",
      "industrial robotics",
      "factory automation",
      "AI manufacturing",
      "machine vision",
      "physical AI"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Japan automotive automation",
      "robotics suppliers",
      "RoboDEX",
      "smart factories"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "Factory Innovation Week Nagoya 2026",
      "robotics event 2026",
      "Japan robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "ieee-isr-sias-2026-osaka",
    "name": "IEEE ISR/SIAS 2026",
    "slug": "ieee-isr-sias-2026-osaka",
    "category": "Research Conferences",
    "country": "Japan",
    "city": "Osaka",
    "region": "Japan",
    "dateStart": "2026-12-02",
    "dateEnd": "2026-12-04",
    "month": "December 2026",
    "venue": "INTEX Osaka",
    "website": "https://unit.aist.go.jp/ircwb/isrsias2026",
    "source": "IEEE Robotics and Automation Society official event page",
    "lastChecked": "August 4, 2026",
    "description": "A conference on intelligence and safety for robotics and industrial automated systems, including human-in-the-loop design, human-robot interaction and operational safety.",
    "audience": [
      "robot safety researchers",
      "industrial engineers",
      "automation companies",
      "regulators",
      "PhD students"
    ],
    "mainTopics": [
      "robot safety",
      "industrial automation safety",
      "human in the loop",
      "human-robot interaction",
      "intelligent systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "robot safety",
      "industrial automated systems",
      "human-centered robotics",
      "research networking"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "IEEE ISR/SIAS 2026",
      "robotics event 2026",
      "Japan robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "robonext-2026-osaka",
    "name": "RoboNext 2026",
    "slug": "robonext-2026-osaka",
    "eventType": "Exhibition",
    "category": "Physical AI",
    "country": "Japan",
    "city": "Osaka",
    "region": "Japan",
    "dateStart": "2026-12-02",
    "dateEnd": "2026-12-04",
    "month": "December 2026",
    "venue": "INTEX Osaka",
    "website": "https://robonext.nikkan.co.jp/",
    "source": "Official RoboNext website",
    "lastChecked": "September 3, 2026",
    "description": "A new Japanese robotics trade show organized by the Japan Robot Association and Nikkan Kogyo Shimbun, with dedicated categories for humanoids, AI, Physical AI, robot software, sensors and components. The official schedule runs 10:00 to 17:00 on December 2 and 3, with a 16:00 close on December 4.",
    "audience": [
      "robot manufacturers",
      "startups",
      "component suppliers",
      "industrial users",
      "technology media"
    ],
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "AI robotics",
      "industrial robots",
      "AMR",
      "robot software",
      "sensors"
    ],
    "organizers": [
      "Japan Robot Association",
      "The Nikkan Kogyo Shimbun"
    ],
    "verifiedFacts": [
      "RoboNext runs December 2 through December 4, 2026 at INTEX Osaka.",
      "Opening hours are 10:00 to 17:00 on December 2 and 3, with the final day closing at 16:00.",
      "The official exhibition categories include AI, Physical AI, robot software, drive systems, sensors, control systems, robot simulation and vision systems.",
      "The organizer's exhibitor material set a target of 300 companies and organizations, 1,000 booths and 40,000 visitors including concurrent exhibitions. These are targets, not completed attendance figures."
    ],
    "technologyHighlights": [
      "humanoid robots",
      "Physical AI",
      "robot software",
      "vision systems",
      "sensors",
      "drives and controls"
    ],
    "officialLinks": [
      { "label": "Official RoboNext site", "url": "https://robonext.nikkan.co.jp/" },
      { "label": "Official exhibitor information", "url": "https://robonext.nikkan.co.jp/exhibit/" }
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Japan humanoid robotics",
      "physical AI",
      "robot components",
      "startup discovery"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Exhibitor information published",
    "statusTone": "open",
    "seoKeywords": [
      "RoboNext 2026",
      "Physical AI exhibition Japan",
      "humanoid robots Osaka",
      "Japan robot exhibition",
      "AI robotics trade show"
    ]
  },
  {
    "id": "humanoid-robot-expo-autumn-2026",
    "name": "Humanoid Robot EXPO 2026 Autumn",
    "originalName": "ヒューマノイドロボットEXPO",
    "officialEnglishName": "Humanoid Robot EXPO",
    "slug": "humanoid-robot-expo-autumn-2026",
    "eventType": "Exhibition",
    "category": "Humanoid Robots",
    "country": "Japan",
    "city": "Chiba",
    "region": "Japan",
    "dateStart": "2026-11-11",
    "dateEnd": "2026-11-13",
    "month": "November 2026",
    "venue": "Makuhari Messe",
    "website": "https://www.nextech-week.jp/hub/ja-jp/about/hr.html",
    "source": "Official NexTech Week Humanoid Robot EXPO page",
    "lastChecked": "October 6, 2026",
    "description": "A specialist exhibition inside NexTech Week focused on humanoid robot deployment. The organizer lists general-purpose, service, care, medical, manufacturing and logistics humanoids together with control software and AI technologies used to operate them.",
    "audience": [
      "humanoid robot companies",
      "manufacturers",
      "logistics operators",
      "healthcare technology teams",
      "robotics software suppliers"
    ],
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "VLM",
      "VLA",
      "robot foundation models",
      "robot operating systems",
      "simulation",
      "digital twins"
    ],
    "organizers": [
      "RX Japan LLC"
    ],
    "verifiedFacts": [
      "The autumn edition runs November 11 through November 13, 2026 at Makuhari Messe.",
      "Official product categories include general-purpose humanoids, service humanoids, care and medical humanoids, and manufacturing and logistics humanoids.",
      "The software category explicitly includes foundation models, VLMs, VLAs, action generation AI, robot operating systems, simulation and digital twins.",
      "Advance visitor registration is required according to the organizer."
    ],
    "technologyHighlights": [
      "VLM",
      "VLA",
      "foundation models",
      "action generation AI",
      "robot OS",
      "simulation and digital twins"
    ],
    "officialLinks": [
      {
        "label": "Official Humanoid Robot EXPO page",
        "url": "https://www.nextech-week.jp/hub/ja-jp/about/hr.html"
      },
      {
        "label": "Official NexTech Week overview",
        "url": "https://www.nextech-week.jp/hub/ja-jp/about.html"
      }
    ],
    "whyItMatters": "The event places humanoid hardware beside the control and Physical AI stack needed for manufacturing, logistics, service and care deployments.",
    "bestFor": [
      "Japan humanoid suppliers",
      "Physical AI",
      "VLA and robot software",
      "deployment technology"
    ],
    "priceRange": "RX Japan lists free advance visitor registration through November 10, 2026, Japan time, followed by JPY 11,000 including tax.",
    "deadline": "Free advance visitor registration ends November 10, 2026, Japan time.",
    "applicationDeadline": "Advance visitor registration is required.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official conference program.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer's current registration documentation.",
    "status": "Registration information published",
    "statusTone": "open",
    "seoKeywords": [
      "Humanoid Robot EXPO 2026 Japan",
      "ヒューマノイドロボットEXPO",
      "Physical AI Expo Japan",
      "humanoid robot exhibition Chiba",
      "VLA robotics Japan"
    ]
  },
  {
    "id": "ieee-humanoids-2026",
    "name": "IEEE-RAS Humanoids 2026",
    "slug": "ieee-humanoids-2026",
    "eventType": "Conference",
    "category": "Humanoid Robots",
    "country": "United States",
    "city": "Santa Clara",
    "region": "United States",
    "dateStart": "2026-12-07",
    "dateEnd": "2026-12-09",
    "month": "December 2026",
    "venue": "Santa Clara Convention Center",
    "website": "https://2026.ieee-humanoids.org/",
    "source": "IEEE Robotics and Automation Society official event page",
    "lastChecked": "August 4, 2026",
    "description": "The IEEE-RAS conference dedicated to humanoid robots, including locomotion, manipulation, cognitive robotics, human-robot interaction, robot learning and service robots.",
    "audience": [
      "humanoid researchers",
      "robotics engineers",
      "PhD students",
      "R&D teams",
      "robot companies"
    ],
    "mainTopics": [
      "humanoid robots",
      "locomotion",
      "manipulation",
      "robot learning",
      "cognitive robotics",
      "human-robot interaction"
    ],
    "organizers": ["IEEE Robotics and Automation Society"],
    "verifiedFacts": [
      "IEEE Robotics and Automation Society lists Humanoids 2026 for December 7 through December 9 at Santa Clara Convention Center.",
      "The conference is dedicated to humanoid robotics and spans locomotion, manipulation, robot learning, cognitive systems and human robot interaction."
    ],
    "technologyHighlights": [
      "whole body control",
      "locomotion",
      "manipulation",
      "robot learning",
      "human robot interaction"
    ],
    "officialLinks": [
      { "label": "Official conference website", "url": "https://2026.ieee-humanoids.org/" }
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "humanoid research",
      "robot learning",
      "locomotion and manipulation",
      "technical networking"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to United States; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "IEEE-RAS Humanoids 2026",
      "robotics event 2026",
      "United States robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "ieee-robio-2026",
    "name": "IEEE ROBIO 2026",
    "slug": "ieee-robio-2026",
    "category": "Research Conferences",
    "country": "China",
    "city": "Tengchong",
    "region": "China",
    "dateStart": "2026-12-16",
    "dateEnd": "2026-12-20",
    "month": "December 2026",
    "venue": "Tengchong Empark Grand Hotel, Yunnan",
    "website": "https://www.ieee-ras.org/event/2026-ieee-international-conference-on-robotics-and-biomimetics-robio-70439/",
    "source": "IEEE Robotics and Automation Society official event page",
    "lastChecked": "August 4, 2026",
    "description": "A robotics and biomimetics conference covering embodied intelligence, autonomous navigation, manipulation, robotic vision, service robots, soft robotics and intelligent manufacturing.",
    "audience": [
      "researchers",
      "PhD students",
      "robotics engineers",
      "biomimetics teams",
      "AI robotics labs"
    ],
    "mainTopics": [
      "embodied intelligence",
      "biomimetic robots",
      "autonomous navigation",
      "manipulation",
      "robotic vision",
      "soft robotics"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "embodied intelligence research",
      "biomimetics",
      "robot vision",
      "China robotics academia"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to China; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "IEEE ROBIO 2026",
      "robotics event 2026",
      "China robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "beijing-yizhuang-humanoid-half-marathon-2027",
    "name": "Beijing Yizhuang Humanoid Robot Half Marathon 2027",
    "originalName": "2027北京亦庄人形机器人半程马拉松",
    "slug": "beijing-yizhuang-humanoid-half-marathon-2027",
    "eventType": "Competition",
    "category": "Robotics Competitions",
    "country": "China",
    "city": "Beijing",
    "region": "China",
    "dateStart": "2027-04-18",
    "dateEnd": "2027-04-18",
    "month": "April 2027",
    "venue": "Beijing E-Town",
    "website": "https://www.beijing.gov.cn/fuwu/lqfw/gggs/202608/t20260824_4833810.html",
    "source": "Beijing Municipal Government official recruitment announcement",
    "lastChecked": "October 6, 2026",
    "description": "The third Beijing Yizhuang humanoid robot half marathon is officially scheduled for April 18, 2027. Global team recruitment was launched during the closing ceremony of World Robot Conference 2026.",
    "audience": [
      "humanoid robot teams",
      "universities",
      "robotics companies",
      "locomotion researchers"
    ],
    "mainTopics": [
      "humanoid locomotion",
      "robot endurance",
      "autonomous navigation",
      "robot sports"
    ],
    "verifiedFacts": [
      "The 2027 race is scheduled for April 18, 2027 in Beijing E-Town.",
      "Global recruitment opened on August 23, 2026 during the World Robot Conference closing program.",
      "The official announcement identifies 2025 and 2026 as the two earlier editions of the Beijing Yizhuang humanoid half marathon."
    ],
    "officialLinks": [
      {
        "label": "Official Beijing recruitment announcement",
        "url": "https://www.beijing.gov.cn/fuwu/lqfw/gggs/202608/t20260824_4833810.html"
      }
    ],
    "whyItMatters": "Teams can prepare for an outdoor humanoid endurance race. The announcement confirms the date and opens recruitment; it does not establish the performance of any 2027 entry.",
    "bestFor": [
      "humanoid locomotion",
      "robot endurance",
      "China humanoid competitions"
    ],
    "priceRange": "Not yet published in the official announcement.",
    "deadline": "Global recruitment has opened. Check the official organizer for team deadlines and technical rules.",
    "applicationDeadline": "Check the official organizer for team deadlines.",
    "exhibitorDeadline": "Not applicable to the current race announcement.",
    "speakerDeadline": "Not applicable.",
    "visaRelevance": "High for international teams traveling to China; use official organizer documentation once team procedures are published.",
    "status": "Global recruitment announced",
    "statusTone": "open",
    "seoKeywords": [
      "Beijing humanoid robot half marathon 2027",
      "Yizhuang robot marathon 2027",
      "humanoid robot race China 2027"
    ]
  },
  {
    "id": "ces-2027-robotics",
    "name": "CES 2027 Robotics and AI",
    "slug": "ces-2027-robotics",
    "category": "Consumer Robotics",
    "country": "United States",
    "city": "Las Vegas",
    "region": "United States",
    "dateStart": "2027-01-06",
    "dateEnd": "2027-01-09",
    "month": "January 2027",
    "venue": "Las Vegas Convention Center and official CES venues",
    "website": "https://www.ces.tech/",
    "source": "Official CES website",
    "lastChecked": "August 4, 2026",
    "description": "The 2027 edition of CES, where robotics companies present consumer robots, AI hardware, mobility systems, sensors, smart-home machines and early commercial prototypes.",
    "audience": [
      "robotics companies",
      "technology buyers",
      "investors",
      "media creators",
      "product teams"
    ],
    "mainTopics": [
      "consumer robotics",
      "AI hardware",
      "mobility",
      "smart home robots",
      "robot sensors",
      "product launches"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "product launches",
      "consumer robotics",
      "AI hardware",
      "media coverage"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to United States; use the organizer’s current registration and invitation-document process.",
    "status": "Dates confirmed - registration notification available",
    "statusTone": "future",
    "seoKeywords": [
      "CES 2027 Robotics and AI",
      "robotics event 2027",
      "United States robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "robotics-warsaw-2027",
    "name": "Robotics Warsaw 2027",
    "slug": "robotics-warsaw-2027",
    "category": "Industrial Automation",
    "country": "Poland",
    "city": "Warsaw",
    "region": "Europe",
    "dateStart": "2027-02-02",
    "dateEnd": "2027-02-04",
    "month": "February 2027",
    "venue": "Ptak Warsaw Expo, Nadarzyn",
    "website": "https://roboticswarsaw.com/en/",
    "source": "Official Robotics Warsaw website",
    "lastChecked": "August 4, 2026",
    "description": "A dedicated industrial robotics trade fair covering robot arms, mobile robots, AI in robotics, machine vision, control software, warehouse automation and systems integration.",
    "audience": [
      "manufacturers",
      "robot suppliers",
      "integrators",
      "industrial buyers",
      "automation engineers"
    ],
    "mainTopics": [
      "industrial robotics",
      "AI in robotics",
      "mobile robots",
      "machine vision",
      "warehouse automation",
      "robot control"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Poland robotics market",
      "industrial robot suppliers",
      "AI robotics",
      "warehouse automation"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Poland; use the organizer’s current registration and invitation-document process.",
    "status": "Registration and exhibitor applications available",
    "statusTone": "open",
    "seoKeywords": [
      "Robotics Warsaw 2027",
      "robotics event 2027",
      "Poland robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "factory-innovation-week-tokyo-2027",
    "name": "Factory Innovation Week Tokyo 2027",
    "slug": "factory-innovation-week-tokyo-2027",
    "category": "Physical AI",
    "country": "Japan",
    "city": "Tokyo",
    "region": "Japan",
    "dateStart": "2027-02-17",
    "dateEnd": "2027-02-19",
    "month": "February 2027",
    "venue": "Tokyo Big Sight",
    "website": "https://www.fiweek.jp/tokyo/en-gb.html",
    "source": "Official RX Japan Factory Innovation Week website",
    "lastChecked": "August 4, 2026",
    "description": "A major Tokyo manufacturing event with RoboDEX robotics and automation, Smart Factory Expo for AI and IoT, and related future-factory technologies.",
    "audience": [
      "manufacturers",
      "robot suppliers",
      "integrators",
      "factory engineers",
      "technology buyers"
    ],
    "mainTopics": [
      "RoboDEX",
      "robotics and automation",
      "AI manufacturing",
      "IoT",
      "machine vision",
      "smart factory"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Japan robotics exhibition",
      "RoboDEX",
      "factory AI",
      "supplier discovery"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "Factory Innovation Week Tokyo 2027",
      "robotics event 2027",
      "Japan robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "european-robotics-forum-2027",
    "name": "European Robotics Forum 2027",
    "slug": "european-robotics-forum-2027",
    "category": "Research Conferences",
    "country": "United Kingdom",
    "city": "Birmingham",
    "region": "Europe",
    "dateStart": "2027-03-02",
    "dateEnd": "2027-03-04",
    "month": "March 2027",
    "venue": "Birmingham, United Kingdom",
    "website": "https://erf2027.eu/",
    "source": "International Federation of Robotics and official ERF 2027 information",
    "lastChecked": "August 4, 2026",
    "description": "Europe’s leading robotics and AI forum, connecting industry, academia and the public sector around research, commercialization, policy and deployment.",
    "audience": [
      "researchers",
      "robotics companies",
      "startups",
      "policy teams",
      "industrial adopters"
    ],
    "mainTopics": [
      "European robotics",
      "AI robotics",
      "research transfer",
      "robotics policy",
      "commercialization",
      "public sector"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "European robotics network",
      "research transfer",
      "funding and policy",
      "industry partnerships"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to United Kingdom; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "European Robotics Forum 2027",
      "robotics event 2027",
      "United Kingdom robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "logimat-2027-stuttgart",
    "name": "LogiMAT 2027",
    "slug": "logimat-2027-stuttgart",
    "category": "Warehouse Robotics",
    "country": "Germany",
    "city": "Stuttgart",
    "region": "Europe",
    "dateStart": "2027-03-16",
    "dateEnd": "2027-03-18",
    "month": "March 2027",
    "venue": "Stuttgart Trade Fair Centre",
    "website": "https://www.logimat-messe.de/en",
    "source": "Official LogiMAT website",
    "lastChecked": "August 4, 2026",
    "description": "A major European intralogistics exhibition for warehouse robotics, AMRs, AGVs, picking, material flow, automation software and intelligent robot assistants.",
    "audience": [
      "warehouse operators",
      "logistics companies",
      "robot suppliers",
      "integrators",
      "industrial buyers"
    ],
    "mainTopics": [
      "warehouse robots",
      "AMR",
      "AGV",
      "picking automation",
      "intralogistics software",
      "material flow"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "warehouse robotics",
      "intralogistics",
      "AMR and AGV comparison",
      "supplier sourcing"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Germany; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "LogiMAT 2027",
      "robotics event 2027",
      "Germany robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "robotics-automation-uk-2027",
    "name": "Robotics & Automation Exhibition 2027",
    "slug": "robotics-automation-uk-2027",
    "category": "Warehouse Robotics",
    "country": "United Kingdom",
    "city": "Birmingham",
    "region": "Europe",
    "dateStart": "2027-03-17",
    "dateEnd": "2027-03-18",
    "month": "March 2027",
    "venue": "NEC Birmingham, Halls 6 and 7",
    "website": "https://www.roboticsandautomation.co.uk/",
    "source": "Official Robotics & Automation Exhibition website",
    "lastChecked": "August 4, 2026",
    "description": "A UK exhibition for robotics, automation and warehouse technology, with live systems, suppliers and an industry conference program.",
    "audience": [
      "warehouse operators",
      "manufacturers",
      "robot suppliers",
      "integrators",
      "technology buyers"
    ],
    "mainTopics": [
      "robotics",
      "warehouse automation",
      "industrial automation",
      "AMR",
      "robot integration",
      "logistics"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "UK robotics market",
      "warehouse automation",
      "supplier comparison",
      "live demonstrations"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to United Kingdom; use the organizer’s current registration and invitation-document process.",
    "status": "Free registration and 2027 stand booking available",
    "statusTone": "open",
    "seoKeywords": [
      "Robotics & Automation Exhibition 2027",
      "robotics event 2027",
      "United Kingdom robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "hannover-messe-2027",
    "name": "HANNOVER MESSE 2027",
    "slug": "hannover-messe-2027",
    "category": "Smart Manufacturing",
    "country": "Germany",
    "city": "Hanover",
    "region": "Europe",
    "dateStart": "2027-04-05",
    "dateEnd": "2027-04-08",
    "month": "April 2027",
    "venue": "Hannover Exhibition Grounds",
    "website": "https://www.hannovermesse.de/en/",
    "source": "Official HANNOVER MESSE website",
    "lastChecked": "August 4, 2026",
    "description": "A large industrial technology exhibition with a dedicated robotics and assembly automation area, plus industrial AI, digital factories, motion and production systems.",
    "audience": [
      "manufacturers",
      "automation suppliers",
      "industrial buyers",
      "robot companies",
      "technology media"
    ],
    "mainTopics": [
      "robotics and assembly automation",
      "industrial AI",
      "smart manufacturing",
      "motion systems",
      "digital factory",
      "production technology"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "global industrial technology",
      "robotics suppliers",
      "industrial AI",
      "smart manufacturing"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Germany; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "HANNOVER MESSE 2027",
      "robotics event 2027",
      "Germany robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "smart-automation-austria-2027",
    "name": "Smart Automation Austria 2027",
    "slug": "smart-automation-austria-2027",
    "category": "Industrial Automation",
    "country": "Austria",
    "city": "Wels",
    "region": "Europe",
    "dateStart": "2027-05-11",
    "dateEnd": "2027-05-13",
    "month": "May 2027",
    "venue": "Messe Wels",
    "website": "https://www.smart-messe.at/",
    "source": "Official Messe Wels and Smart Automation Austria information",
    "lastChecked": "August 4, 2026",
    "description": "Austria’s specialist platform for industrial automation, moving to Messe Wels for its 2027 edition.",
    "audience": [
      "Austrian manufacturers",
      "automation engineers",
      "integrators",
      "component suppliers",
      "industrial buyers"
    ],
    "mainTopics": [
      "industrial automation",
      "robotics",
      "control systems",
      "drives",
      "sensors",
      "factory technology"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Austria automation market",
      "industrial robotics",
      "regional suppliers",
      "factory technology"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Austria; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "Smart Automation Austria 2027",
      "robotics event 2027",
      "Austria robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "factory-innovation-week-osaka-2027",
    "name": "Factory Innovation Week Osaka 2027",
    "slug": "factory-innovation-week-osaka-2027",
    "category": "Physical AI",
    "country": "Japan",
    "city": "Osaka",
    "region": "Japan",
    "dateStart": "2027-05-12",
    "dateEnd": "2027-05-14",
    "month": "May 2027",
    "venue": "INTEX Osaka",
    "website": "https://www.fiweek.jp/hub/en-gb.html",
    "source": "Official RX Japan Factory Innovation Week website",
    "lastChecked": "August 4, 2026",
    "description": "The Osaka edition of Factory Innovation Week, including RoboDEX robotics and automation technologies and Smart Factory Expo.",
    "audience": [
      "manufacturers",
      "robot suppliers",
      "integrators",
      "factory engineers",
      "technology buyers"
    ],
    "mainTopics": [
      "RoboDEX",
      "robotics and automation",
      "AI manufacturing",
      "smart factory",
      "machine vision",
      "physical AI"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Western Japan robotics market",
      "RoboDEX",
      "physical AI",
      "factory automation"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Japan; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "Factory Innovation Week Osaka 2027",
      "robotics event 2027",
      "Japan robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "international-industrial-forum-ukraine-2027",
    "name": "International Industrial Forum Ukraine 2027",
    "slug": "international-industrial-forum-ukraine-2027",
    "category": "Industrial Automation",
    "country": "Ukraine",
    "city": "Kyiv",
    "region": "Europe",
    "dateStart": "2027-05-25",
    "dateEnd": "2027-05-27",
    "month": "May 2027",
    "venue": "International Exhibition Centre, Kyiv",
    "website": "https://www.iec-expo.com.ua/en/",
    "source": "Official International Exhibition Centre Kyiv calendar",
    "lastChecked": "August 4, 2026",
    "description": "An industrial forum whose official program includes Automation and Robotics, process control, warehouse equipment, machine building and industrial safety.",
    "audience": [
      "Ukrainian manufacturers",
      "automation suppliers",
      "industrial engineers",
      "integrators",
      "technology buyers"
    ],
    "mainTopics": [
      "automation and robotics",
      "process control",
      "warehouse equipment",
      "machine building",
      "industrial safety"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Ukraine robotics and automation",
      "industrial partnerships",
      "manufacturing systems",
      "regional suppliers"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the organizer’s current security, access, registration and travel notices before making arrangements.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "International visitors should review current official travel and security guidance in addition to the organizer’s registration information.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "International Industrial Forum Ukraine 2027",
      "robotics event 2027",
      "Ukraine robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {
    "id": "automatica-2027-munich",
    "name": "automatica 2027",
    "slug": "automatica-2027-munich",
    "category": "Physical AI",
    "country": "Germany",
    "city": "Munich",
    "region": "Europe",
    "dateStart": "2027-06-22",
    "dateEnd": "2027-06-25",
    "month": "June 2027",
    "venue": "Trade Fair Center Messe München",
    "website": "https://automatica-munich.com/en/",
    "source": "Messe Munich and International Federation of Robotics",
    "lastChecked": "October 6, 2026",
    "description": "automatica covers industrial robots, assembly, handling, machine vision and robotics software in Munich. The 2027 edition also names Physical AI and humanoid robotics among its focus areas. Exhibitor applications are available; individual demonstrations depend on the final program.",
    "audience": [
      "robot manufacturers",
      "integrators",
      "component suppliers",
      "industrial buyers",
      "technology media"
    ],
    "mainTopics": [
      "industrial robotics",
      "Physical AI",
      "humanoid robotics",
      "machine vision"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "robot hardware comparison",
      "physical AI",
      "European automation suppliers",
      "live industrial demonstrations"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Germany; use the organizer’s current registration and invitation-document process.",
    "status": "Exhibitor applications available",
    "statusTone": "open",
    "seoKeywords": [
      "automatica 2027",
      "Physical AI Munich",
      "robotics trade show Germany",
      "industrial robot exhibition",
      "smart automation"
    ],
    "officialLinks": [
      {
        "label": "Organizer dates and exhibition sectors",
        "url": "https://automatica-munich.com/en/"
      },
      {
        "label": "IFR listing and 2027 focus areas",
        "url": "https://ifr.org/event"
      }
    ]
  },
  {
    "id": "advanced-design-manufacturing-toronto-2027",
    "name": "Advanced Design & Manufacturing Toronto 2027",
    "slug": "advanced-design-manufacturing-toronto-2027",
    "category": "Industrial Automation",
    "country": "Canada",
    "city": "Toronto",
    "region": "North America",
    "dateStart": "2027-11-09",
    "dateEnd": "2027-11-11",
    "month": "November 2027",
    "venue": "Toronto Congress Centre",
    "website": "https://www.admtoronto.com/",
    "source": "Official Advanced Design & Manufacturing Toronto website",
    "lastChecked": "August 4, 2026",
    "description": "A multi-brand manufacturing event that includes ATX Canada for automation, robotics, controls and production technology.",
    "audience": [
      "manufacturers",
      "automation engineers",
      "robot suppliers",
      "product designers",
      "industrial buyers"
    ],
    "mainTopics": [
      "automation",
      "robotics",
      "controls",
      "manufacturing technology",
      "design engineering",
      "production systems"
    ],
    "whyItMatters": "This confirmed event provides a practical view of current robotics research, commercial systems, suppliers, deployment constraints and emerging applications.",
    "bestFor": [
      "Canadian manufacturing market",
      "automation suppliers",
      "robotics integration",
      "engineering networking"
    ],
    "priceRange": "Check official registration page.",
    "deadline": "Check the official event page for registration, exhibition and program deadlines.",
    "applicationDeadline": "Check the official event page.",
    "exhibitorDeadline": "Check the official exhibitor page.",
    "speakerDeadline": "Check the official call or program page.",
    "visaRelevance": "High for international visitors traveling to Canada; use the organizer’s current registration and invitation-document process.",
    "status": "Date confirmed",
    "statusTone": "future",
    "seoKeywords": [
      "Advanced Design & Manufacturing Toronto 2027",
      "robotics event 2027",
      "Canada robotics",
      "robotics exhibition",
      "physical AI event"
    ]
  },
  {id:"taros-2026-manchester",name:"TAROS 2026",slug:"taros-2026-manchester",eventType:"Conference",category:"Research Conferences",country:"United Kingdom",city:"Manchester",region:"Europe",dateStart:"2026-09-07",dateEnd:"2026-09-09",month:"September 2026",venue:"Manchester, United Kingdom",website:"https://www.ieee-ras.org/event/2026-27th-conference-on-towards-autonomous-robotic-systems-taros-68751/",source:"IEEE Robotics and Automation Society",lastChecked:"September 24, 2026",description:"Conference on autonomous robotic systems covering perception, planning, learning, control and field robotics.",mainTopics:["autonomous robots","robot learning","perception","planning","control"],whyItMatters:"Useful for research on autonomy and real-world robot behavior.",status:"Completed",statusTone:"past",seoKeywords:["TAROS 2026","Manchester robotics conference","autonomous robots"]},
  {id:"sice-festival-2026-yokohama",name:"SICE FESTIVAL 2026",slug:"sice-festival-2026-yokohama",eventType:"Conference",category:"Research Conferences",country:"Japan",city:"Yokohama",region:"Japan",dateStart:"2026-09-14",dateEnd:"2026-09-17",month:"September 2026",venue:"Yokohama, Japan",website:"https://sicefes26.sice.jp/",source:"Official SICE FESTIVAL 2026 website",lastChecked:"September 24, 2026",description:"International conference on control, measurement, systems, robotics and related engineering.",mainTopics:["control","robotics","sensing","automation","systems"],whyItMatters:"Connects control research with robotics hardware and industrial systems.",status:"Completed",statusTone:"past",seoKeywords:["SICE FESTIVAL 2026","Yokohama robotics","control conference"]},
  {id:"ieee-icdl-2026-kyoto",name:"IEEE ICDL 2026",slug:"ieee-icdl-2026-kyoto",eventType:"Conference",category:"Research Conferences",country:"Japan",city:"Kyoto",region:"Japan",dateStart:"2026-09-15",dateEnd:"2026-09-18",month:"September 2026",venue:"Kyoto, Japan",website:"https://www.ieee-ras.org/event/2026-ieee-international-conference-on-development-and-learning-icdl-67399/",source:"IEEE Robotics and Automation Society",lastChecked:"September 24, 2026",description:"Research conference on developmental learning, embodied learning, cognition and lifelong robot learning.",mainTopics:["embodied learning","developmental robotics","lifelong learning","human robot interaction"],whyItMatters:"Relevant to Physical AI systems that must learn reusable skills instead of one fixed task.",status:"Completed",statusTone:"past",seoKeywords:["ICDL 2026","Kyoto embodied learning","developmental robotics"]},
  {id:"apsara-conference-2026-hangzhou",name:"Apsara Conference 2026",slug:"apsara-conference-2026-hangzhou",eventType:"Conference",category:"AI Robotics",country:"China",city:"Hangzhou",region:"China",dateStart:"2026-09-22",dateEnd:"2026-09-24",month:"September 2026",venue:"Hangzhou International Expo Center",website:"https://www.ehangzhou.gov.cn/2026-09/03/c_298873.htm",source:"Hangzhou official international portal",lastChecked:"September 24, 2026",description:"Large AI conference covering chips, cloud infrastructure, foundation models, agents and industrial AI applications.",mainTopics:["AI models","agents","AI chips","cloud infrastructure","industrial AI"],whyItMatters:"Provides model and compute context for Physical AI and robot foundation models.",status:"In progress",statusTone:"open",seoKeywords:["Apsara Conference 2026","Hangzhou AI conference","Physical AI China"]},
  {id:"global-digital-trade-expo-2026-hangzhou",name:"Global Digital Trade Expo 2026",slug:"global-digital-trade-expo-2026-hangzhou",eventType:"Exhibition",category:"Physical AI",country:"China",city:"Hangzhou",region:"China",dateStart:"2026-09-23",dateEnd:"2026-09-27",month:"September 2026",venue:"Hangzhou Grand Convention and Exhibition Center",website:"https://www.ehangzhou.gov.cn/2026-09/08/c_298929.htm",source:"Hangzhou official international portal",lastChecked:"September 24, 2026",description:"Digital trade expo with embodied intelligence competitions, humanoid robots, intelligent hardware and AI applications.",mainTopics:["embodied intelligence","humanoid robots","AI","robotics competitions","smart hardware"],whyItMatters:"One of the strongest September 2026 China signals for new humanoid products and embodied AI applications.",status:"In progress",statusTone:"open",seoKeywords:["Global Digital Trade Expo 2026","Hangzhou humanoid robots","embodied intelligence expo"]},
  {id:"icmme-2026-dalian",name:"ICMME 2026",slug:"icmme-2026-dalian",eventType:"Conference",category:"Industrial Automation",country:"China",city:"Dalian",region:"China",dateStart:"2026-10-16",dateEnd:"2026-10-18",month:"October 2026",venue:"Dalian, China",website:"https://www.ieee-ras.org/events/category/conferences/list/",source:"IEEE Robotics and Automation Society event calendar",lastChecked:"September 24, 2026",description:"Conference covering mechatronics, manufacturing, automation and robotics.",mainTopics:["mechatronics","manufacturing","robotics","automation"],whyItMatters:"Useful for industrial robot hardware and manufacturing research.",status:"Upcoming",statusTone:"future",seoKeywords:["ICMME 2026","Dalian robotics conference","mechatronics China"]},
  {id:"industrial-transformation-asia-pacific-2026",name:"Industrial Transformation Asia-Pacific 2026",slug:"industrial-transformation-asia-pacific-2026",eventType:"Trade Show",category:"Smart Manufacturing",country:"Singapore",city:"Singapore",region:"Singapore",dateStart:"2026-10-21",dateEnd:"2026-10-22",month:"October 2026",venue:"Suntec Singapore",website:"https://industrial-transformation.com/programme/",source:"Official Industrial Transformation Asia-Pacific programme",lastChecked:"September 24, 2026",description:"Industrial technology event with a 2026 keynote focused on Physical AI, humanoids and cognitive robotics.",mainTopics:["Physical AI","humanoid robots","cognitive robotics","smart manufacturing"],whyItMatters:"Directly connects Physical AI with factory deployment and manufacturing economics.",status:"Upcoming",statusTone:"future",seoKeywords:["Industrial Transformation Asia-Pacific 2026","Physical AI Singapore","humanoid robotics manufacturing"]},
  {id:"icairs-2026-tianjin",name:"ICAIRS 2026",slug:"icairs-2026-tianjin",eventType:"Conference",category:"AI Robotics",country:"China",city:"Tianjin",region:"China",dateStart:"2026-10-23",dateEnd:"2026-10-25",month:"October 2026",venue:"Tianjin, China",website:"https://www.ieee-ras.org/event/2026-international-conference-on-artificial-intelligence-and-robotic-systems-icairs-72058/",source:"IEEE Robotics and Automation Society",lastChecked:"September 24, 2026",description:"International conference on artificial intelligence and robotic systems.",mainTopics:["robot intelligence","AI robotics","perception","control","autonomy"],whyItMatters:"Relevant to embodied AI models and autonomous robot systems.",status:"Upcoming",statusTone:"future",seoKeywords:["ICAIRS 2026","Tianjin robotics","AI robotic systems"]},
  {id:"iccas-2026-sapporo",name:"ICCAS 2026",slug:"iccas-2026-sapporo",eventType:"Conference",category:"Research Conferences",country:"Japan",city:"Sapporo",region:"Japan",dateStart:"2026-10-27",dateEnd:"2026-10-30",month:"October 2026",venue:"Hotel Emisia Sapporo",website:"https://2026.iccas.org/",source:"Official ICCAS 2026 website",lastChecked:"September 24, 2026",description:"International conference on control, automation, robotics and systems with tutorials, technical sessions and invited talks.",mainTopics:["control","automation","robotics","multi-agent systems","data-driven control"],whyItMatters:"Useful for whole-body control, robot coordination and control-system research.",status:"Upcoming",statusTone:"future",seoKeywords:["ICCAS 2026","Sapporo robotics conference","control automation robotics"]},
  {
    "slug": "nvidia-gtc-berlin-2026",
    "name": "NVIDIA GTC Berlin 2026",
    "category": "Physical AI",
    "eventType": "Conference and workshops",
    "country": "Germany",
    "city": "Berlin",
    "region": "Europe",
    "dateStart": "2026-10-20",
    "dateEnd": "2026-10-22",
    "venue": "STATION-Berlin and Tempodrom",
    "website": "https://www.nvidia.com/en-eu/gtc/",
    "source": "NVIDIA GTC Berlin",
    "description": "NVIDIA's Berlin program includes robotics and Physical AI sessions, including a talk on accelerating humanoid development with AI agents. Workshops run on October 20; the conference and exhibition run on October 21 and 22.",
    "mainTopics": [
      "Physical AI",
      "humanoid development",
      "robotics software"
    ],
    "organizers": [
      "NVIDIA"
    ],
    "id": "nvidia-gtc-berlin-2026",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "October 2026",
    "officialLinks": []
  },
  {
    "slug": "corl-2026-austin",
    "name": "Conference on Robot Learning 2026",
    "category": "Research Conferences",
    "eventType": "Conference and workshops",
    "country": "United States",
    "city": "Austin",
    "region": "United States",
    "dateStart": "2026-11-09",
    "dateEnd": "2026-11-12",
    "venue": "JW Marriott Austin, Hilton Austin and Bass Hall",
    "website": "https://2026.corl.org/",
    "source": "CoRL 2026 organizing committee",
    "description": "CoRL brings robotics and machine learning research together in Austin. The main conference runs November 9 to 11, followed by workshops on November 12. The organizer lists three venues, so attendees should check the location of each session.",
    "mainTopics": [
      "robot learning",
      "embodied AI",
      "machine learning"
    ],
    "officialLinks": [
      {
        "label": "Conference and workshop schedule",
        "url": "https://2026.corl.org/program"
      }
    ],
    "status": "Registration open",
    "id": "corl-2026-austin",
    "lastChecked": "October 6, 2026",
    "statusTone": "future",
    "month": "November 2026"
  },
  {
    "slug": "physical-ai-expo-autumn-2026",
    "name": "Physical AI EXPO 2026 Autumn",
    "category": "Physical AI",
    "eventType": "Exhibition",
    "country": "Japan",
    "city": "Chiba",
    "region": "Japan",
    "dateStart": "2026-11-11",
    "dateEnd": "2026-11-13",
    "venue": "Makuhari Messe",
    "website": "https://www.nextech-week.jp/hub/ja-jp/about/ph.html",
    "source": "RX Japan NexTech Week",
    "description": "This exhibition within NexTech Week focuses on AI systems that perceive and act in physical environments. It runs alongside Humanoid Robot EXPO at Makuhari Messe. The organizer presents it as a place to compare deployment technologies and discuss their use with suppliers.",
    "mainTopics": [
      "Physical AI",
      "robot perception",
      "robot deployment"
    ],
    "organizers": [
      "RX Japan"
    ],
    "id": "physical-ai-expo-autumn-2026",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "November 2026",
    "officialLinks": []
  },
  {
    "slug": "nvidia-gtc-washington-2026",
    "name": "NVIDIA GTC Washington DC 2026",
    "category": "Physical AI",
    "eventType": "Conference and workshops",
    "country": "United States",
    "city": "Washington, DC",
    "region": "United States",
    "dateStart": "2026-11-30",
    "dateEnd": "2026-12-03",
    "venue": "Ronald Reagan Building and International Trade Center and other city venues",
    "website": "https://www.nvidia.com/gtc/dc/",
    "source": "NVIDIA GTC Washington DC",
    "description": "Physical AI is one of the topics in this broader NVIDIA developer conference, alongside computing infrastructure and scientific applications. Workshops take place on November 30. The conference and exhibition run December 1 to 3, with sessions and live demonstrations announced by the organizer.",
    "mainTopics": [
      "Physical AI",
      "AI computing",
      "developer workshops"
    ],
    "organizers": [
      "NVIDIA"
    ],
    "id": "nvidia-gtc-washington-2026",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "November 2026",
    "officialLinks": []
  },
  {
    "slug": "humanoids-summit-silicon-valley-2026",
    "name": "Humanoids Summit Silicon Valley 2026",
    "category": "Humanoid Robots",
    "eventType": "Summit",
    "country": "United States",
    "city": "San Mateo",
    "region": "United States",
    "dateStart": "2026-12-01",
    "dateEnd": "2026-12-02",
    "venue": "San Mateo Event Center",
    "website": "https://humanoidssummit.com/",
    "source": "Humanoids Summit",
    "description": "Humanoids Summit returns to Silicon Valley for talks, exhibitions and live humanoid demonstrations. The 2026 event moves to San Mateo Event Center. The organizer has confirmed the dates and venue; the Silicon Valley speaker list was still awaiting announcement when checked.",
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "commercial deployment"
    ],
    "organizers": [
      "Humanoids Summit"
    ],
    "id": "humanoids-summit-silicon-valley-2026",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "December 2026",
    "officialLinks": []
  },
  {
    "slug": "gitex-world-robotix-2026-dubai",
    "name": "GITEX World RobotiX 2026",
    "category": "Physical AI",
    "eventType": "Exhibition",
    "country": "United Arab Emirates",
    "city": "Dubai",
    "region": "Middle East",
    "dateStart": "2026-12-08",
    "dateEnd": "2026-12-11",
    "venue": "Dubai Exhibition Centre, Expo City Dubai",
    "website": "https://www.gitex.com/robotix",
    "source": "GITEX World RobotiX",
    "description": "GITEX World RobotiX brings humanoids and embodied AI into the GITEX exhibition in Dubai. The announced themes include manufacturing, warehouse operations, mobility and service robots. Live demonstrations, product launches and buyer meetings are planned; an exhibition demonstration does not establish performance in a customer's workplace.",
    "mainTopics": [
      "humanoid robots",
      "embodied AI",
      "warehouse robotics"
    ],
    "id": "gitex-world-robotix-2026-dubai",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "December 2026",
    "officialLinks": []
  },
  {
    "slug": "advanced-humanoid-forum-2027-munich",
    "name": "Advanced Humanoid Forum 2027",
    "category": "Humanoid Robots",
    "eventType": "Forum",
    "country": "Germany",
    "city": "Munich",
    "region": "Europe",
    "dateStart": "2027-01-20",
    "dateEnd": "2027-01-21",
    "venue": "Midnightbazar Munich",
    "website": "https://advancedhumanoidforum.com/index.html",
    "source": "Advanced Humanoid Forum",
    "description": "The forum focuses on testing humanoid robots for industrial use, with Physical AI and embodied AI validation in its announced program. The organizer plans live validation areas. Test protocols, robot configurations and measured results should be checked as the detailed program becomes available.",
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "industrial validation"
    ],
    "organizers": [
      "ULMO-Consulting"
    ],
    "id": "advanced-humanoid-forum-2027-munich",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "January 2027",
    "officialLinks": []
  },
  {
    "slug": "nvidia-gtc-2027-san-jose",
    "name": "NVIDIA GTC San Jose 2027",
    "category": "Physical AI",
    "eventType": "Hybrid conference",
    "country": "United States",
    "city": "San Jose",
    "region": "United States",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "announcedMonth": 3,
    "date": "March 2027, exact event window to be confirmed",
    "dateNote": "NVIDIA's main page advertises March 15 to 18; its FAQ gives March 14 to 18. Confirm which days apply to your pass before booking.",
    "venue": "San Jose McEnery Convention Center and other city venues",
    "website": "https://www.nvidia.com/gtc/",
    "source": "NVIDIA GTC announcement and FAQ",
    "description": "NVIDIA has announced the return of GTC to San Jose, with Physical AI among its conference topics and both online and in-person attendance. The main page and FAQ currently give different start dates. The listing keeps the month visible while the full event window needs clarification.",
    "mainTopics": [
      "Physical AI",
      "robotics software",
      "AI computing"
    ],
    "organizers": [
      "NVIDIA"
    ],
    "officialLinks": [
      {
        "label": "GTC date and attendance FAQ",
        "url": "https://www.nvidia.com/gtc/faq/"
      }
    ],
    "id": "nvidia-gtc-2027-san-jose",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "March 2027"
  },
  {
    "slug": "geia-asia-2027-shanghai",
    "name": "GEIA Asia 2027",
    "category": "Physical AI",
    "eventType": "Summit and exhibition",
    "country": "China",
    "city": "Shanghai",
    "region": "China",
    "dateStart": "2027-04-13",
    "dateEnd": "2027-04-16",
    "venue": "Venue not announced",
    "website": "https://www.geiaasia.com/registration.html",
    "source": "GEIA Asia registration schedule",
    "description": "GEIA's Shanghai program covers embodied intelligence and humanoid robotics. Its registration schedule separates a founders' meeting on April 13, the main stage on April 14, technical and application sessions on April 15, and a site visit on April 16. Access depends on the pass and session.",
    "mainTopics": [
      "embodied AI",
      "humanoid robots",
      "robot applications"
    ],
    "organizers": [
      "GEIA"
    ],
    "dateNote": "The full announced program is April 13 to 16. The public event calendar also lists April 14 to 16; April 13 is the founders' meeting.",
    "officialLinks": [
      {
        "label": "Event scope and announcement",
        "url": "https://www.geiaasia.com/index.html"
      }
    ],
    "id": "geia-asia-2027-shanghai",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "April 2027"
  },
  {
    "slug": "humanoid-robot-expo-spring-2027-tokyo",
    "name": "Humanoid Robot EXPO 2027 Spring",
    "category": "Humanoid Robots",
    "eventType": "Exhibition",
    "country": "Japan",
    "city": "Tokyo",
    "region": "Japan",
    "dateStart": "2027-04-21",
    "dateEnd": "2027-04-23",
    "venue": "Tokyo Big Sight",
    "website": "https://www.nextech-week.jp/hub/en-gb.html",
    "source": "RX Japan NexTech Week",
    "description": "Humanoid Robot EXPO is part of the spring NexTech Week exhibition at Tokyo Big Sight. The show connects humanoid hardware with software and technologies for robots working around people. RX Japan has announced the 2027 spring dates; exhibitors and individual demonstrations should be checked for that edition.",
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "robot control"
    ],
    "organizers": [
      "RX Japan"
    ],
    "id": "humanoid-robot-expo-spring-2027-tokyo",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "April 2027",
    "officialLinks": []
  },
  {
    "slug": "humanoids-summit-tokyo-2027",
    "name": "Humanoids Summit Tokyo 2027",
    "category": "Humanoid Robots",
    "eventType": "Summit",
    "country": "Japan",
    "city": "Tokyo",
    "region": "Japan",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "announcedMonth": 5,
    "date": "May 2027, exact dates not announced",
    "venue": "Venue not announced",
    "website": "https://prtimes.jp/main/html/rd/p/000000003.000180712.html",
    "source": "Humanoids Summit Inc. organizer announcement",
    "description": "Humanoids Summit Inc. has announced a return to Tokyo in May 2027. The announcement covers humanoids, Physical AI and autonomous systems, but does not give exact days or a 2027 venue. The previous Tokyo edition's speakers and demonstrations are not a confirmed 2027 program.",
    "mainTopics": [
      "humanoid robots",
      "Physical AI",
      "autonomous systems"
    ],
    "organizers": [
      "Humanoids Summit"
    ],
    "officialLinks": [
      {
        "label": "Humanoids Summit website",
        "url": "https://humanoidssummit.com/"
      }
    ],
    "id": "humanoids-summit-tokyo-2027",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "May 2027"
  },
  {
    "slug": "automate-2027-las-vegas",
    "name": "Automate 2027",
    "category": "Industrial Automation",
    "eventType": "Trade show and conference",
    "country": "United States",
    "city": "Las Vegas",
    "region": "United States",
    "dateStart": "2027-05-10",
    "dateEnd": "2027-05-13",
    "venue": "Las Vegas Convention Center",
    "website": "https://www.automateshow.com/",
    "source": "Association for Advancing Automation",
    "description": "Automate covers industrial robots, machine vision, motion control and automation integration. Its 2027 program includes a separate Humanoid Robot Forum on May 11 and 12. Exhibition registration and the forum have different access conditions, so visitors should check which sessions their pass includes.",
    "mainTopics": [
      "industrial robots",
      "humanoid robots",
      "machine vision"
    ],
    "organizers": [
      "Association for Advancing Automation"
    ],
    "officialLinks": [
      {
        "label": "Humanoid Robot Forum dates and access",
        "url": "https://www.automateshow.com/attend/humanoid-robot-forum"
      }
    ],
    "id": "automate-2027-las-vegas",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "May 2027"
  },
  {
    "slug": "humanoid-robot-forum-automate-2027",
    "name": "Humanoid Robot Forum at Automate 2027",
    "category": "Humanoid Robots",
    "eventType": "Forum",
    "country": "United States",
    "city": "Las Vegas",
    "region": "United States",
    "dateStart": "2027-05-11",
    "dateEnd": "2027-05-12",
    "venue": "Las Vegas Convention Center",
    "website": "https://www.automateshow.com/attend/humanoid-robot-forum",
    "source": "Association for Advancing Automation",
    "description": "This two-day forum within Automate examines humanoid development, deployment and commercialization through panels and interviews. Forum registration includes access to the Automate show floor. The organizer's page currently displays conflicting ticket prices, so no price is reproduced here.",
    "mainTopics": [
      "humanoid robots",
      "commercial deployment",
      "industrial robotics"
    ],
    "organizers": [
      "Association for Advancing Automation"
    ],
    "id": "humanoid-robot-forum-automate-2027",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "May 2027",
    "officialLinks": []
  },
  {
    "slug": "ieee-icra-2027-seoul",
    "name": "IEEE ICRA 2027",
    "category": "Research Conferences",
    "eventType": "Conference",
    "country": "South Korea",
    "city": "Seoul",
    "region": "South Korea",
    "dateStart": "2027-05-24",
    "dateEnd": "2027-05-28",
    "venue": "COEX",
    "website": "https://2027.ieee-icra.org/",
    "source": "IEEE ICRA 2027 organizing committee",
    "description": "The IEEE International Conference on Robotics and Automation takes place at COEX in Seoul. Its contribution categories include research papers, workshops, tutorials and competitions. Use the edition's published program to identify humanoid and robot-learning sessions as they are announced.",
    "mainTopics": [
      "robotics research",
      "robot learning",
      "automation"
    ],
    "organizers": [
      "IEEE Robotics and Automation Society"
    ],
    "id": "ieee-icra-2027-seoul",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "May 2027",
    "officialLinks": []
  },
  {
    "slug": "iras-2027-shenzhen",
    "name": "Intelligent Robots and Autonomous Systems 2027",
    "category": "Research Conferences",
    "eventType": "Conference",
    "country": "China",
    "city": "Shenzhen",
    "region": "China",
    "dateStart": "2027-05-28",
    "dateEnd": "2027-05-30",
    "venue": "Venue not announced",
    "website": "https://www.iras.org.cn/chinese.html",
    "source": "IRAS 2027 organizing committee",
    "description": "IRAS is organized by Southeast University and hosted by Southern University of Science and Technology. The announced schedule puts registration on May 28, talks and posters on May 29, and an academic or cultural visit on May 30. It covers intelligent robotics and autonomous systems.",
    "mainTopics": [
      "intelligent robotics",
      "autonomous systems"
    ],
    "organizers": [
      "Southeast University",
      "Southern University of Science and Technology"
    ],
    "id": "iras-2027-shenzhen",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "May 2027",
    "officialLinks": []
  },
  {
    "slug": "robotics-summit-expo-2027-boston",
    "name": "Robotics Summit and Expo 2027",
    "category": "AI Robotics",
    "eventType": "Conference and exhibition",
    "country": "United States",
    "city": "Boston",
    "region": "United States",
    "dateStart": "2027-06-02",
    "dateEnd": "2027-06-03",
    "venue": "John B. Hynes Convention Center",
    "website": "https://www.roboticssummit.com/faq/",
    "source": "Robotics Summit and Expo organizer FAQ",
    "description": "The summit returns to Boston for engineers and companies building commercial robotic systems. The organizer confirms the John B. Hynes Convention Center for 2027 and shared exhibit-floor access with DeviceTalks Boston. The published FAQ is the source for this edition's dates and venue.",
    "mainTopics": [
      "commercial robotics",
      "robot development",
      "robot components"
    ],
    "officialLinks": [
      {
        "label": "Robotics Summit website",
        "url": "https://www.roboticssummit.com/"
      }
    ],
    "id": "robotics-summit-expo-2027-boston",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "June 2027"
  },
  {
    "slug": "robocup-2027-nuremberg",
    "name": "RoboCup 2027 Nuremberg",
    "category": "Robotics Competitions",
    "eventType": "Competition and symposium",
    "country": "Germany",
    "city": "Nuremberg",
    "region": "Europe",
    "dateStart": "2027-06-17",
    "dateEnd": "2027-06-21",
    "venue": "Nuremberg Exhibition Center",
    "website": "https://2027.robocup.org/wm27/",
    "source": "RoboCup Germany",
    "description": "RoboCup brings autonomous robot competitions to Nuremberg, covering soccer, service tasks, rescue and industrial applications. The event page lists June 17 to 21, while public visitor days run June 17 to 20. Team preparation dates may start earlier and depend on the league.",
    "mainTopics": [
      "humanoid soccer",
      "autonomous robots",
      "service robotics"
    ],
    "organizers": [
      "RoboCup Germany"
    ],
    "officialLinks": [
      {
        "label": "Public visitor dates",
        "url": "https://2027.robocup.org/visit/visitors"
      },
      {
        "label": "RoboCup league changes",
        "url": "https://www.robocup.org/news/181"
      }
    ],
    "id": "robocup-2027-nuremberg",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "June 2027"
  },
  {
    "slug": "machina-summit-2027-paris",
    "name": "Machina Summit 2027",
    "category": "Physical AI",
    "eventType": "Summit",
    "country": "France",
    "city": "Paris",
    "region": "Europe",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "announcedMonth": 7,
    "date": "July 2027, exact dates not announced",
    "venue": "Palais des Congres de Paris",
    "website": "https://www.machinasummit.com/",
    "source": "Machina Summit announcement",
    "description": "Machina Summit advertises a July 2027 edition in Paris focused on robotics and Physical AI. The page names the Palais des Congres but still contains material from 2026. Exact 2027 days and the edition-specific program need confirmation.",
    "mainTopics": [
      "Physical AI",
      "embodied AI",
      "robotics"
    ],
    "id": "machina-summit-2027-paris",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "July 2027",
    "officialLinks": []
  },
  {
    "slug": "geia-gba-2027-shenzhen",
    "name": "GEIA Greater Bay Area 2027",
    "category": "Physical AI",
    "eventType": "Conference and exhibition",
    "country": "China",
    "city": "Shenzhen",
    "region": "China",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "announcedMonth": 9,
    "date": "September 2027, exact dates to be confirmed",
    "venue": "Venue not announced",
    "website": "https://www.geiaapac.com/index.html",
    "source": "GEIA Greater Bay Area announcement",
    "description": "The Shenzhen edition of GEIA covers embodied AI, humanoids and components such as sensors and actuators. Organizer pages give different September date ranges. The month is listed here until the schedule is consistent.",
    "mainTopics": [
      "embodied AI",
      "humanoid robots",
      "robot components"
    ],
    "organizers": [
      "GEIA"
    ],
    "officialLinks": [
      {
        "label": "GEIA regional calendar",
        "url": "https://www.geiaasia.com/"
      }
    ],
    "dateNote": "The organizer's pages show September 22 to 24 and September 8 to 11. Exact dates require clarification.",
    "id": "geia-gba-2027-shenzhen",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "September 2027"
  },
  {
    "slug": "ieee-iros-2027-florence",
    "name": "IEEE RSJ IROS 2027",
    "category": "Research Conferences",
    "eventType": "Conference",
    "country": "Italy",
    "city": "Florence",
    "region": "Europe",
    "dateStart": "2027-09-26",
    "dateEnd": "2027-10-01",
    "venue": "Fortezza da Basso",
    "website": "https://www.ieee-ras.org/event/2027-ieee-rsj-international-conference-on-intelligent-robots-and-systems-iros-70525/",
    "source": "IEEE Robotics and Automation Society event calendar",
    "description": "IROS 2027 is scheduled in Florence for research on intelligent robots and systems. The IEEE calendar emphasizes human-centred robotics and sustainable applications. September 26 to October 1 is the window published by IEEE RAS; check the conference program for individual workshop and presentation days.",
    "mainTopics": [
      "intelligent robots",
      "human robot interaction",
      "robotics research"
    ],
    "officialLinks": [
      {
        "label": "IROS 2027 conference website",
        "url": "https://2027.ieee-iros.org/"
      }
    ],
    "id": "ieee-iros-2027-florence",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "September 2027"
  },
  {
    "slug": "geia-asean-2027-bangkok",
    "name": "GEIA ASEAN 2027",
    "category": "Physical AI",
    "eventType": "Conference",
    "country": "Thailand",
    "city": "Bangkok",
    "region": "Asia Pacific",
    "dateStart": "2027-10-21",
    "dateEnd": "2027-10-23",
    "venue": "Venue not announced",
    "website": "https://www.geiaapac.com/index.html",
    "source": "GEIA global event calendar",
    "description": "GEIA's regional calendar announces an ASEAN edition in Bangkok on October 21 to 23. The series focuses on embodied intelligence and humanoid robotics. A venue and detailed Bangkok program were not available in the announcement checked.",
    "mainTopics": [
      "embodied AI",
      "humanoid robots"
    ],
    "organizers": [
      "GEIA"
    ],
    "dateNote": "Dates announced in the GEIA network calendar. A dedicated edition program and venue still need confirmation.",
    "id": "geia-asean-2027-bangkok",
    "lastChecked": "October 6, 2026",
    "status": "Date confirmed",
    "statusTone": "future",
    "month": "October 2027",
    "officialLinks": []
  },
  {
    "slug": "geia-middle-east-2027-dubai",
    "name": "GEIA Middle East 2027",
    "category": "Physical AI",
    "eventType": "Conference",
    "country": "United Arab Emirates",
    "city": "Dubai",
    "region": "Middle East",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "date": "2027, dates to be confirmed",
    "venue": "Venue not announced",
    "website": "https://www.geiaasia.com/index.html",
    "source": "GEIA global event calendar",
    "description": "GEIA announces a Dubai edition focused on embodied intelligence and humanoid robotics. Its regional pages show different months, including September and October. The event remains on the 2027 watchlist with no exact date or venue assigned.",
    "mainTopics": [
      "embodied AI",
      "humanoid robots"
    ],
    "organizers": [
      "GEIA"
    ],
    "dateNote": "Organizer pages disagree on the month. Confirm the schedule directly with GEIA before making travel arrangements.",
    "officialLinks": [
      {
        "label": "GEIA regional announcement",
        "url": "https://www.geiaeurope.com/SPONSOR.html"
      }
    ],
    "id": "geia-middle-east-2027-dubai",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "2027"
  },
  {
    "slug": "irex-2027-tokyo",
    "name": "International Robot Exhibition 2027",
    "category": "Industrial Automation",
    "eventType": "Exhibition",
    "country": "Japan",
    "city": "",
    "region": "Japan",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "announcedMonth": 12,
    "date": "Early December 2027, exact dates not announced",
    "venue": "Venue to be confirmed for 2027",
    "website": "https://irex.nikkan.co.jp/",
    "source": "iREX organizer announcement",
    "description": "The iREX organizer says the next International Robot Exhibition is planned for early December 2027. The show covers industrial and service robotics. Exact days and the 2027 program are not yet established by that announcement; the 2025 exhibitor list should not be treated as the next edition's lineup.",
    "mainTopics": [
      "industrial robots",
      "service robots",
      "robot components"
    ],
    "organizers": [
      "Japan Robot Association",
      "Nikkan Kogyo Shimbun"
    ],
    "id": "irex-2027-tokyo",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "December 2027",
    "officialLinks": []
  },
  {
    "slug": "geia-china-2027-beijing",
    "name": "GEIA China 2027",
    "category": "Physical AI",
    "eventType": "Conference",
    "country": "China",
    "city": "Beijing",
    "region": "China",
    "dateStart": null,
    "dateEnd": null,
    "announcedYear": 2027,
    "announcedMonth": 12,
    "date": "December 2027, exact dates to be confirmed",
    "venue": "Venue not announced",
    "website": "https://www.geiaasia.com/index.html",
    "source": "GEIA global event calendar",
    "description": "GEIA lists a Beijing edition for December 2027 in its embodied intelligence and humanoid event series. Its pages disagree on the final day. The calendar therefore records the month and leaves the precise window unconfirmed.",
    "mainTopics": [
      "embodied AI",
      "humanoid robots"
    ],
    "organizers": [
      "GEIA"
    ],
    "dateNote": "Organizer calendars show December 8 to 10 and December 8 to 11.",
    "officialLinks": [
      {
        "label": "Alternate organizer calendar",
        "url": "https://www.geiaasia.com/"
      }
    ],
    "id": "geia-china-2027-beijing",
    "lastChecked": "October 6, 2026",
    "status": "Dates to be confirmed",
    "statusTone": "future",
    "month": "December 2027"
  }
];

export const pastRoboticsEvents = [
  {
    "id": "world-humanoid-robot-games-2025",
    "name": "World Humanoid Robot Games 2025",
    "eventType": "Competition",
    "category": "Humanoid Robots",
    "country": "China",
    "city": "Beijing",
    "originalName": "2025世界人形机器人运动会",
    "dateStart": "2025-08-14",
    "dateEnd": "2025-08-17",
    "date": "August 14-17, 2025",
    "website": "https://www.whrgoc.com/",
    "articlePath": "/robotics-news/world-humanoid-robot-games-2025",
    "reasonToArchive": "Inaugural edition 280 teams from 16 countries, 500+ humanoid robots, 26 events and 487 matches at Beijing’s National Speed Skating Oval. Dedicated results archive /robotics-news/world-humanoid-robot-games-2025",
    "status": "Past event"
  },
  {
    "id": "beijing-yizhuang-humanoid-half-marathon-2025",
    "name": "Beijing Yizhuang Humanoid Robot Half Marathon 2025",
    "eventType": "Competition",
    "originalName": "2025北京亦庄人形机器人半程马拉松",
    "category": "Robotics Competitions",
    "country": "China",
    "city": "Beijing",
    "dateStart": "2025-04-19",
    "dateEnd": "2025-04-19",
    "date": "April 19, 2025",
    "website": "https://www.beijing.gov.cn/fuwu/lqfw/gggs/202608/t20260824_4833810.html",
    "reasonToArchive": "The inaugural Beijing Yizhuang humanoid half marathon had 20 robot teams. Tiangong Ultra won in 2 hours 40 minutes 42 seconds according to Beijing's official 2027 recruitment announcement.",
    "status": "Past event"
  },
  {
    "id": "world-robot-conference-2025",
    "name": "World Robot Conference 2025",
    "eventType": "Conference, exhibition and competition",
    "originalName": "2025世界机器人大会",
    "category": "Humanoid Robots",
    "country": "China",
    "city": "Beijing",
    "dateStart": "2025-08-08",
    "dateEnd": "2025-08-12",
    "date": "August 8-12, 2025",
    "website": "https://www.worldrobotconference.com/en/",
    "reasonToArchive": "The 2025 Beijing edition ran August 8 through August 12. Official Beijing reporting described an exhibition above 50,000 square meters with about 200 exhibitors and more than 100 debut products.",
    "status": "Past event"
  },
  {
    "id": "waic-2025-shanghai",
    "name": "World Artificial Intelligence Conference 2025",
    "eventType": "Conference and exhibition",
    "originalName": "2025世界人工智能大会",
    "category": "Research Conferences",
    "country": "China",
    "city": "Shanghai",
    "dateStart": "2025-07-26",
    "dateEnd": "2025-07-29",
    "date": "July 26-29, 2025",
    "website": "https://www.worldaic.com.cn/",
    "reasonToArchive": "The 2025 WAIC conference opened July 26 with exhibition activity through July 29. Shanghai official reporting counted more than 800 companies, over 3,000 AI products and more than 60 intelligent robots in the exhibition.",
    "status": "Past event"
  },
  {
    "id": "world-robot-conference-2024",
    "name": "World Robot Conference 2024",
    "eventType": "Conference, exhibition and competition",
    "originalName": "2024世界机器人大会",
    "category": "Humanoid Robots",
    "country": "China",
    "city": "Beijing",
    "dateStart": "2024-08-21",
    "dateEnd": "2024-08-25",
    "date": "August 21-25, 2024",
    "website": "https://www.worldrobotconference.com/en/",
    "reasonToArchive": "The 2024 World Robot Conference ran August 21 through August 25 in Beijing and used the established conference, exhibition and competition format.",
    "status": "Past event"
  },
  {
    id: "irex-2025",
    name: "iREX 2025 International Robot Exhibition",
    category: "Industrial Automation",
    country: "Japan",
    city: "Tokyo",
    dateStart: "2025-12-03",
    dateEnd: "2025-12-06",
    date: "December 3-6, 2025",
    website: "https://www.jara.jp/about/img/release/jigyo_hokoku/jara_jigyo_hokoku_2025.pdf",
    source: "Japan Robot Association fiscal 2025 report",
    officialLinks: [{ label: "JARA organizer report", url: "https://www.jara.jp/about/img/release/jigyo_hokoku/jara_jigyo_hokoku_2025.pdf" }, { label: "Epson exhibitor venue confirmation", url: "https://corporate.epson/en/news/2025/251120.html" }],
    lastChecked: "October 11, 2026",
    reasonToArchive: "Tokyo Big Sight exhibition of industrial robots and related components. JARA records the December 3-6 edition in its fiscal 2025 report.",
    status: "Past event"
  },
  {
    id: "automate-2026-archive-note",
    name: "Automate 2026",
    category: "Industrial Automation",
    country: "United States",
    city: "Chicago",
    dateStart: "2026-06-22",
    dateEnd: "2026-06-25",
    date: "June 22-25, 2026",
    website: "https://www.automateshow.com/userAssets/file/Automate-Exhibitor-Prospectus-2026.pdf",
    source: "A3 Automate 2026 exhibitor prospectus",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The Chicago edition covered robot systems, machine vision, motion control and factory automation. The A3 prospectus records June 22-25 at McCormick Place.",
    status: "Past event"
  },
  {
    id: "ces-2026",
    name: "CES 2026 Robotics Coverage",
    category: "Consumer Robotics",
    country: "United States",
    city: "Las Vegas",
    dateStart: "2026-01-06",
    dateEnd: "2026-01-09",
    date: "January 6-9, 2026",
    website: "https://www.ces.tech/press-releases/what-not-to-miss-at-ces-2026",
    source: "CTA CES 2026 press release",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The Las Vegas programme covered consumer technology, including robotics, accessibility, mobility and AI hardware. The CTA announcement records January 6-9.",
    status: "Past event"
  },
  {
    id: "modeX-2026",
    name: "MODEX 2026",
    category: "Warehouse Robotics",
    country: "United States",
    city: "Atlanta",
    dateStart: "2026-04-13",
    dateEnd: "2026-04-16",
    date: "April 13-16, 2026",
    website: "https://mhiblog.org/why-modex-2026-is-a-must-attend-event-for-supply-chain-pros/",
    source: "MHI MODEX 2026 event announcement",
    lastChecked: "October 11, 2026",
    reasonToArchive: "MHI held the supply-chain exhibition at the Georgia World Congress Center in Atlanta. The programme covered material handling, warehouse automation and logistics.",
    status: "Past event"
  },
  {
    id: "ismr-2026",
    name: "International Symposium on Medical Robotics 2026",
    category: "Medical Robotics",
    country: "United States",
    city: "Knoxville",
    dateStart: "2026-04-22",
    dateEnd: "2026-04-24",
    date: "April 22-24, 2026",
    website: "https://ismr.gatech.edu/2026/workshop_tutorial_submission",
    source: "ISMR 2026 organizing committee",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The Knoxville meeting covered surgical, rehabilitation and assistive robotics. Workshops ran April 22, followed by the single-track symposium on April 23-24 at the University of Tennessee Conference Center.",
    status: "Past event"
  },
  {
    id: "hannover-messe-2026",
    name: "Hannover Messe 2026",
    category: "Industrial Automation",
    country: "Germany",
    city: "Hannover",
    dateStart: "2026-04-20",
    dateEnd: "2026-04-24",
    date: "April 20-24, 2026",
    website: "https://www.hannovermesse.de/en/press/press-releases/hannover-messe/hannover-messe-launches-call-for-participation",
    source: "Hannover Messe organizer announcement",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The Hannover edition covered industrial automation, energy infrastructure and research transfer. Its organizer announcement records April 20-24 and identifies Brazil as the partner country.",
    status: "Past event"
  },
  {
    id: "dronitaly-2026",
    name: "Dronitaly 2026",
    category: "Drone Robotics",
    country: "Italy",
    city: "Bologna",
    dateStart: "2026-03-11",
    dateEnd: "2026-03-13",
    date: "March 11-13, 2026",
    website: "https://www.dronitaly.it/en/News/Dronitaly-is-officially-the-only-international-industry-event-in-Italy",
    source: "Dronitaly organizer announcement",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The eleventh Dronitaly edition took place at BolognaFiere Ex GAM. The organizer listed civil drone applications, conferences and technical roundtables for March 11-13.",
    status: "Past event"
  },
  {
    id: "german-robotics-conference-2026",
    name: "2nd German Robotics Conference",
    category: "Research Conferences",
    country: "Germany",
    city: "Cologne",
    dateStart: "2026-03-11",
    dateEnd: "2026-03-13",
    date: "March 11-13, 2026",
    website: "https://robotics-institute-germany.de/event/grc/",
    source: "Robotics Institute Germany event archive",
    lastChecked: "October 11, 2026",
    reasonToArchive: "Robotics Institute Germany held its second conference at Koelnmesse in Cologne. The archive retains the March 11-13 programme, research sessions and workshops.",
    status: "Past event"
  },
  {
    id: "european-robotics-forum-2026",
    name: "European Robotics Forum 2026",
    category: "Research Conferences",
    country: "Norway",
    city: "Stavanger",
    dateStart: "2026-03-23",
    dateEnd: "2026-03-27",
    date: "March 23-27, 2026 including side events",
    website: "https://erf2026.eu/press/",
    source: "European Robotics Forum 2026 organizer facts",
    lastChecked: "October 11, 2026",
    reasonToArchive: "NORCE and SINTEF hosted the forum in Stavanger with euRobotics. The organizer lists March 23-27 including side events; individual sessions had their own dates and venues.",
    status: "Past event"
  },
  {
    id: "humanoids-summit-tokyo-2026",
    name: "Humanoids Summit Tokyo 2026",
    category: "Humanoid Robots",
    country: "Japan",
    city: "Tokyo",
    dateStart: "2026-05-28",
    dateEnd: "2026-05-29",
    date: "May 28-29, 2026",
    website: "https://humanoidssummit.com/agenda-2",
    source: "Humanoids Summit Tokyo 2026 official agenda",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The two-day Tokyo programme included manipulation, tactile sensing, simulation, deployment and robot safety. The archived agenda lists sessions on May 28 and 29.",
    status: "Past event"
  },
  {
    id: "arso-2026",
    name: "IEEE ARSO 2026",
    category: "Research Conferences",
    country: "Austria",
    city: "Vienna",
    dateStart: "2026-06-10",
    dateEnd: "2026-06-12",
    date: "June 10-12, 2026",
    website: "https://www.ieee-ras.org/event/2026-ieee-international-conference-on-advanced-robotics-and-its-social-impacts-arso-68304/",
    source: "IEEE Robotics and Automation Society event record",
    lastChecked: "October 11, 2026",
    reasonToArchive: "IEEE ARSO met at TU Wien in Vienna on June 10-12. The programme covered robot technologies and their social, economic and human-interaction effects.",
    status: "Past event"
  },
  {
    id: "robot-technology-japan-2026",
    name: "Robot Technology Japan 2026",
    category: "Industrial Automation",
    country: "Japan",
    city: "Aichi",
    dateStart: "2026-06-11",
    dateEnd: "2026-06-13",
    date: "June 11-13, 2026",
    website: "https://robot-technology.jp/en/about/",
    source: "Robot Technology Japan 2026 organizer outline",
    lastChecked: "October 11, 2026",
    reasonToArchive: "The Aichi Sky Expo edition covered industrial robots, automated systems and robot components. News Digest Publishing lists June 11-13 in the official exhibition outline.",
    status: "Past event"
  }
];

export const roboticsEventSubpages = [
  {
    slug: "conferences",
    title: "Robotics Conferences",
    description: "Research conferences such as ICRA, IROS, RSS, IEEE-RAS Humanoids, RO-MAN, WAIC and ROSCon are useful for papers, workshops, PhD networking and technical roadmaps. The calendar also tracks specialist humanoid and Embodied AI forums when official programs are available.",
    categories: ["Research Conferences", "Robotics Software", "Medical Robotics"],
    keywords: ["robotics conferences", "robotics conferences 2026 and 2027", "robotics research events"]
  },
  {
    slug: "exhibitions",
    title: "Robotics Exhibitions and Trade Shows",
    description: "Exhibitions are best for seeing robot arms, cobots, sensors, grippers, drives, warehouse robots, drones, and suppliers that can actually be contacted.",
    categories: ["Industrial Automation", "Robot Components", "Warehouse Robotics", "Drone Robotics", "Consumer Robotics"],
    keywords: ["robotics exhibitions", "robotics trade shows", "robot component exhibitions"]
  },
  {
    slug: "humanoid-robot-events",
    title: "Humanoid Robot Events",
    description: "Humanoid robot events include conferences, exhibitions and scored competitions. Evaluate locomotion, manipulation, autonomy disclosure, battery runtime, safety setup, teleoperation use and evidence from repeated tasks or field conditions.",
    categories: ["Humanoid Robots", "AI Robotics", "Physical AI", "Research Conferences", "Startup and Investor Events", "Robotics Competitions"],
    keywords: ["humanoid robot events", "humanoid robotics conference", "physical AI events"]
  },
  {
    slug: "industrial-automation-events",
    title: "Industrial Automation Events",
    description: "Industrial automation events are where robotics becomes practical robot cells, sensors, drives, motion control, safety systems, machine vision, PLCs, grippers, and system integrators.",
    categories: ["Industrial Automation", "Robot Components", "Warehouse Robotics"],
    keywords: ["industrial automation events", "robotics trade shows", "factory automation events"]
  },
  {
    slug: "robotics-competitions",
    title: "Robotics Competitions",
    description: "Robot competitions reveal robustness because teams must solve perception, localization, control, manipulation, autonomy, and recovery under public scoring pressure.",
    categories: ["Robotics Competitions", "Research Conferences"],
    keywords: ["robotics competitions", "RoboCup 2027", "student robotics competitions"]
  },
  {
    slug: "startup-demo-days",
    title: "Robotics Startup Demo Days",
    description: "Startup demo days and commercial robotics events are useful for fundraising, pilot customers, hiring, partnerships, media coverage, and supplier discovery.",
    categories: ["Startup and Investor Events", "AI Robotics", "Consumer Robotics"],
    keywords: ["robotics startup events", "robotics demo days", "robotics investor events"]
  }
];

export const eventCategoryGuides = [
  {
    category: "Humanoid Robots",
    summary: "Focus on whole body control, bipedal stability, dexterous manipulation, safety around people, autonomy disclosure, and whether the demo shows repeatable useful work.",
    bestEvents: ["World Humanoid Robot Games", "World Robot Conference", "IEEE-RAS Humanoids", "Humanoids Summit", "China Humanoid Robot Ecology Conference", "Humanoid Robot EXPO"],
    internalLink: "/robot-types/humanoid-robots"
  },
  {
    category: "Industrial Automation",
    summary: "Look for robot cells, cobots, machine vision, safety scanners, PLC integration, end effectors, motion control, cycle time, and service support.",
    bestEvents: ["Automate", "SPS", "Hannover Messe", "automatica", "International Symposium on Robotics"],
    internalLink: "/robot-types/industrial-robots"
  },
  {
    category: "AI Robotics",
    summary: "Separate model based claims from embodied performance. Ask what was autonomous, what was teleoperated, what data was used, and how failure recovery works.",
    bestEvents: ["WAIC", "World Robot Conference", "ICRA", "IROS", "RSS", "RoboNext"],
    internalLink: "/robotics-topics"
  },
  {
    category: "Medical Robotics",
    summary: "Medical robotics events require a clinical lens safety evidence, surgeon workflow, training time, regulatory path, ergonomics, and patient value.",
    bestEvents: ["Hamlyn Symposium", "ISMR", "IROS medical robotics workshops"],
    internalLink: "/robot-types/medical-surgical-robots"
  },
  {
    category: "Warehouse Robotics",
    summary: "Watch AMR fleet behavior, charging strategy, throughput, integration with WMS, pick rate claims, exception handling, and deployment economics.",
    bestEvents: ["LogiMAT", "MODEX", "Automate", "RoboBusiness"],
    internalLink: "/robot-types/warehouse-robots-amrs"
  },
  {
    category: "Drone Robotics",
    summary: "Evaluate payload, flight time, sensing, mapping accuracy, regulatory conditions, safety systems, data workflows, and inspection repeatability.",
    bestEvents: ["Commercial UAV Expo", "Dronitaly", "IROS aerial robotics sessions"],
    internalLink: "/robot-types/drones-aerial-robots"
  },
  {
    category: "Robot Components and Hardware",
    summary: "Component events help compare motors, reducers, grippers, batteries, embedded computers, cooling, connectors, cameras, LiDAR, force sensors, and supplier maturity.",
    bestEvents: ["Automate", "SPS", "Manufacturing World Tokyo", "Hannover Messe", "automatica", "ROBOTWORLD"],
    internalLink: "/robot-components"
  }
];

export const regionGuides = [
  {
    region: "China",
    summary: "China is important for humanoid robots, robot dogs, industrial robots, embodied AI demonstrations, supply chains, and high volume manufacturing signals.",
    watchFor: ["World Robot Conference", "World Humanoid Robot Games", "WAIC embodied AI tracks", "China Humanoid Robot Ecology Conference", "Beijing Yizhuang Humanoid Robot Half Marathon"]
  },
  {
    region: "Japan",
    summary: "Japan is strong for industrial robots, service robots, manufacturing components, robot exhibitions, precision engineering, and long running robotics culture.",
    watchFor: ["RO-MAN", "RoboNext", "Humanoid Robot EXPO", "HuRoC EXPO", "Humanoids Summit Tokyo", "iREX", "Japan Robot Week"]
  },
  {
    region: "United States",
    summary: "The United States is strong for robotics startups, AI robotics, university research, commercial robotics, warehouse automation, drones, and investor events.",
    watchFor: ["Robotics Summit & Expo", "Automate", "IROS", "RoboBusiness", "Commercial UAV Expo", "CES"]
  },
  {
    region: "Europe",
    summary: "Europe is strong for industrial automation, automation components, warehouse robotics, medical robotics, safety standards, and robotics research.",
    watchFor: ["Hannover Messe", "SPS", "LogiMAT", "automatica", "European Robotics Forum", "German Robotics Conference"]
  },
  {
    region: "Middle East",
    summary: "Dubai hosts GITEX World RobotiX in December 2026. GEIA also announces a Dubai edition for 2027, but its pages disagree on the month. The calendar keeps that edition visible with dates to be confirmed.",
    watchFor: ["GITEX World RobotiX 2026", "GEIA Middle East 2027"]
  },
  {
    region: "Asia beyond China and Japan",
    summary: "ICRA 2027 takes place in Seoul. Singapore hosts Industrial Transformation Asia-Pacific in October 2026, with Physical AI in the program. GEIA lists an ASEAN edition in Bangkok for October 2027; its venue and detailed program remain unannounced.",
    watchFor: ["ICRA 2027 Seoul", "Industrial Transformation Asia-Pacific 2026", "GEIA ASEAN 2027 Bangkok"]
  },
  {
    region: "Africa",
    summary: "Africa focused robotics opportunities often appear through university competitions, AI events, drone applications, agriculture technology, healthcare innovation, and industrial automation showcases.",
    watchFor: ["student robotics competitions", "AI summits", "agritech events", "drone and mapping forums"]
  },
  {
    region: "Global online events",
    summary: "Online events are useful for students and creators who cannot travel. They are best for webinars, virtual workshops, technical launch streams, and open source robotics community events.",
    watchFor: ["ROS webinars", "open source robotics talks", "company launch streams", "technical workshops"]
  }
];

export const audienceGuides = [
  {
    audience: "For startups",
    title: "Which robotics events help startups?",
    points: [
      "Use commercial events such as RoboBusiness and Robotics Summit to meet investors, customers, component suppliers, manufacturing partners, and media teams.",
      "Use industrial shows such as Automate, SPS, and Hannover Messe when the startup sells factory automation, robot arms, grippers, sensors, safety systems, AMRs, or integration services.",
      "Use research conferences only when the startup has defensible technology, strong demos, hiring needs, or technical credibility to build with engineers and researchers.",
      "For fundraising, prepare a working demo, deployment evidence, clear unit economics, support plan, and honest limits. Robotics investors look for more than a polished video."
    ]
  },
  {
    audience: "For content creators and journalists",
    title: "Which events create the best robotics content?",
    points: [
      "Humanoid, robot dog, drone, and robot competition events usually produce strong visual content, but the best coverage explains sensors, autonomy, control, safety, and real use cases.",
      "Ask press teams for media accreditation, demo schedules, interview slots, filming rules, booth numbers, and whether demos are live, assisted, teleoperated, or scripted.",
      "The most useful robotics content compares what the audience sees with what the robot can actually repeat outside the booth.",
      "Avoid presenting security or defense robotics as operational advice. Keep coverage educational, safety focused, and non operational."
    ]
  },
  {
    audience: "For engineers and students",
    title: "Which events are best for learning?",
    points: [
      "ICRA, IROS, RSS, Humanoids, ROSCon, and RoboCup are strong for papers, workshops, tutorials, PhD networking, internships, and robotics software.",
      "Students should prioritize events with workshops, poster sessions, competitions, open source communities, and recruiting activity.",
      "Engineers should use trade shows to compare hardware reality actuator heat, gearbox backlash, sensor mounting, cable routing, safety scanners, and integration support.",
      "The best question to ask after every demo is simple what fails first after 1,000 hours of real operation?"
    ]
  }
];

export const eventFaqs = [
  {
    question: "Are all 2027 event dates confirmed?",
    answer: "No. Some organizers have announced only a month, and some official pages give conflicting dates. These entries are marked Dates to be confirmed. They remain searchable by year and by an announced month when one is available, but are not placed on a specific day in the calendar. Check the organizer page before booking."
  },
  {
    question: "Which robotics events are listed through 2027?",
    answer: "The calendar includes humanoid summits, Physical AI exhibitions, research conferences and robot competitions through December 2027. Examples include ICRA in Seoul, IROS in Florence, Humanoid Robot EXPO in Tokyo, Automate in Las Vegas and GITEX World RobotiX in Dubai. Use the year, region and topic filters to narrow the list. Each listing links to its organizer source."
  },
  {
    question: "Which robotics events focus on humanoid robots?",
    answer: "Humanoid robots appear at World Humanoid Robot Games, World Robot Conference, IEEE-RAS Humanoids, Humanoids Summit, China Humanoid Robot Ecology Conference, RoboNext, HuRoC EXPO and Japan's Humanoid Robot EXPO. RoboCup also includes a dedicated Humanoid Soccer League. Evaluate autonomy disclosure, hand capability, whole body control, balance recovery, battery runtime, payload, safety setup and evidence from repeated tasks."
  },
  {
    question: "Which robotics conferences are best for researchers?",
    answer: "ICRA, IROS, RSS, Humanoids, ISMR, Hamlyn Symposium, ROSCon, and RoboCup Symposium are strong choices for researchers. Each has a different emphasis ICRA and IROS are broad, RSS is selective and science focused, ROSCon is software focused, Hamlyn and ISMR are medical robotics focused, and RoboCup connects research with competition benchmarks."
  },
  {
    question: "Which robotics events are best for startups?",
    answer: "Robotics Summit, RoboBusiness, Automate, CES, Commercial UAV Expo, and logistics events such as LogiMAT are useful for startups because they combine customers, suppliers, investors, integrators, and media. Research conferences are useful when the startup needs technical hiring or credibility."
  },
  {
    question: "How much does it cost to attend a robotics conference?",
    answer: "Pricing varies widely. Some trade show expo halls are free with registration, while research conferences and full conference passes can cost hundreds or more depending on membership, student status, and deadline. When prices are not public, TechniaHQRobot marks the price as not publicly listed instead of inventing a number."
  },
  {
    question: "Which robotics events are best for finding robot suppliers?",
    answer: "Automate, SPS, Manufacturing World Tokyo, Hannover Messe, LogiMAT, and Robotics Summit are useful for supplier discovery. Look for motors, reducers, grippers, cameras, LiDAR, force sensors, batteries, embedded computers, cables, connectors, frames, safety scanners, and integration partners."
  },
  {
    question: "Which robotics events are important in China and Japan?",
    answer: "In China, World Robot Conference, World Humanoid Robot Games, WAIC embodied AI programs, China Humanoid Robot Ecology Conference and the Beijing Yizhuang Humanoid Robot Half Marathon provide different views of humanoids, components and robot learning. In Japan, RoboNext, HuRoC EXPO, Humanoids Summit Tokyo, Humanoid Robot EXPO, iREX and RO-MAN cover research, deployment, Physical AI and supplier activity."
  },
  {
    question: "What is the difference between a robotics conference and a robotics convention?",
    answer: "A robotics conference usually centers on papers, workshops and technical talks. A robotics convention or trade show centers on booths, products, demos, buyers, hiring, media and partnerships. ICRA and IROS are conferences. Automate, SPS, LogiMAT, Hannover Messe and automatica are trade shows."
  },
  {
    question: "What are the best robotics events in Europe?",
    answer: "Strong European robotics events include Hannover Messe, SPS, LogiMAT, automatica, European Robotics Forum, German Robotics Conference, Hamlyn Symposium and European editions of humanoid or Physical AI summits."
  },
  {
    question: "What robotics events are useful for robot hardware companies?",
    answer: "Robot hardware companies should watch Automate, SPS, Hannover Messe, automatica, Manufacturing World Tokyo, Robot Technology Japan, ROBOTWORLD and RoboDEX because these events surface actuators, motors, grippers, sensors, controllers, robot arms and integration partners."
  },
  {
    question: "Where can startups meet robotics investors?",
    answer: "Startups should prioritize RoboBusiness, Robotics Summit and Expo, European Robotics Forum, CES, GITEX Physical AI, Automate and strong regional AI or robotics summits. The best setup is a safe demo, deployment evidence, pilot pricing and a clear support plan."
  },
  {
    question: "What trade shows are useful for industrial robots?",
    answer: "Automate, SPS, Hannover Messe, LogiMAT, automatica, Manufacturing World Tokyo, RoboDEX, ROBOTWORLD and World Robot Conference are useful because they show robot arms, cobots, machine vision, end effectors, safety scanners, AMRs, software and integrators."
  },
  {
    question: "Which events are best for robot component sourcing?",
    answer: "Automate, SPS, Manufacturing World Tokyo, Hannover Messe, and Robotics Summit are good places to compare actuators, servo motors, brushless motors, harmonic drives, cycloidal reducers, end effectors, batteries, AI accelerators, embedded computers, industrial cameras, LiDAR, and safety sensors."
  },
  {
    question: "How can a startup exhibit at a robotics event?",
    answer: "Start by choosing an event that matches the buyer. Prepare a safe working demo, short technical brief, booth video, press kit, pricing logic, pilot offer, support plan, and clear contact process. Then check official exhibitor deadlines, startup booth packages, sponsor options, and media accreditation rules."
  }
];

export function eventMatchesSubpage(event, subpage) {
  if (!subpage) return true;
  const topicText = [event.name, event.description, ...(event.mainTopics || [])].join(" ").toLowerCase();
  if (subpage.slug === "humanoid-robot-events") {
    return event.category === "Humanoid Robots" || /humanoid|physical ai|embodied ai|embodied intelligence/.test(topicText);
  }
  if (subpage.slug === "robotics-competitions") {
    return event.category === "Robotics Competitions" || /competition|games|race/.test(String(event.eventType || "").toLowerCase());
  }
  if (subpage.categories.includes(event.category)) return true;

  const eventType = String(event.eventType || "").toLowerCase();
  if (subpage.slug === "conferences") {
    return /conference|summit|forum|symposium/.test(eventType);
  }
  if (subpage.slug === "exhibitions") {
    return /expo|exhibition|trade show/.test(eventType);
  }
  if (subpage.slug === "robotics-competitions") {
    return /competition|games|race/.test(eventType);
  }
  return false;
}

export function getEventsBySubpage(slug) {
  const subpage = roboticsEventSubpages.find((item) => item.slug === slug);
  if (!subpage) return { subpage: null, events: roboticsEvents };
  const events = roboticsEvents.filter((event) => eventMatchesSubpage(event, subpage));
  return { subpage, events };
}
